import { createIconFromPath } from '../lib/icon';

export const ApplyAllOutline = createIconFromPath({
	displayName: 'ApplyAllOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<g clipPath="url(#clip0_2537_85979)">
				<path d="M1.5 12.2147L5.1 15.75L13.5 7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M11.8088 13.5L14.1001 15.75L22.5001 7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			</g>
			<defs>
				<clipPath id="clip0_2537_85979">
					<rect width="24" height="24" fill="currentColor" />
				</clipPath>
			</defs>
		</>
	),
});

export const ArrowGenerativeOutline = createIconFromPath({
	displayName: 'ArrowGenerativeOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.1241 5.40307C8.35386 5.74771 8.26073 6.21337 7.91609 6.44313C5.13638 8.29627 4.39014 10.524 4.39014 12.4407C4.39014 16.7154 7.85545 20.1807 12.1301 20.1807C16.4048 20.1807 19.8701 16.7154 19.8701 12.4407C19.8701 12.0265 20.2059 11.6907 20.6201 11.6907C21.0343 11.6907 21.3701 12.0265 21.3701 12.4407C21.3701 17.5438 17.2332 21.6807 12.1301 21.6807C7.02703 21.6807 2.89014 17.5438 2.89014 12.4407C2.89014 10.0511 3.86374 7.34192 7.08404 5.19505C7.42868 4.96529 7.89433 5.05842 8.1241 5.40307Z"
				fill="currentColor"
			/>
			<path
				d="M2.62988 5.51929L7.50988 5.51929C7.57616 5.51929 7.62988 5.57301 7.62988 5.63929L7.62988 10.5193"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<g clipPath="url(#clip0_8721_50770)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M16.2001 3.51904C16.4723 3.51904 16.7104 3.70233 16.7801 3.96551L17.4876 6.6384L19.4999 7.79933C19.6856 7.90649 19.8001 8.10462 19.8001 8.31904C19.8001 8.53347 19.6856 8.7316 19.4999 8.83875L17.4876 9.99969L16.7801 12.6726C16.7104 12.9358 16.4723 13.119 16.2001 13.119C15.9278 13.119 15.6897 12.9358 15.62 12.6726L14.9125 9.99968L12.9003 8.83875C12.7145 8.7316 12.6001 8.53347 12.6001 8.31904C12.6001 8.10462 12.7145 7.90649 12.9003 7.79933L14.9125 6.6384L15.62 3.96551C15.6897 3.70233 15.9278 3.51904 16.2001 3.51904Z"
					fill="currentColor"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M11.9562 8.99976C12.1042 8.99976 12.2336 9.09936 12.2714 9.24237L12.6559 10.6948L13.7494 11.3257C13.8503 11.3839 13.9125 11.4916 13.9125 11.6081C13.9125 11.7246 13.8503 11.8323 13.7494 11.8905L12.6559 12.5214L12.2714 13.9738C12.2336 14.1168 12.1042 14.2164 11.9562 14.2164C11.8083 14.2164 11.6789 14.1168 11.6411 13.9738L11.2566 12.5214L10.1631 11.8905C10.0622 11.8323 10 11.7246 10 11.6081C10 11.4916 10.0622 11.3839 10.1631 11.3257L11.2566 10.6948L11.6411 9.24237C11.6789 9.09936 11.8083 8.99976 11.9562 8.99976Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_8721_50770">
					<rect width="12" height="12" fill="currentColor" transform="translate(9 2.31909)" />
				</clipPath>
			</defs>
		</>
	),
});

export const AwardRibbonOutline = createIconFromPath({
	displayName: 'AwardRibbonOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<circle cx="12" cy="9" r="7" stroke="currentColor" strokeWidth="1.5" />
			<path d="M8 15V21L12 18.5L16 21V15" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
		</>
	),
});

export const BlockquoteOutline = createIconFromPath({
	displayName: 'BlockquoteOutline',
	viewBox: '0 0 20 20',
	path: (
		<>
			<g clipPath="url(#clip0_1474_15462)">
				<path
					d="M8.4375 11.25H3.125C2.95924 11.25 2.80027 11.1842 2.68306 11.0669C2.56585 10.9497 2.5 10.7908 2.5 10.625V5.625C2.5 5.45924 2.56585 5.30027 2.68306 5.18306C2.80027 5.06585 2.95924 5 3.125 5H7.8125C7.97826 5 8.13723 5.06585 8.25444 5.18306C8.37165 5.30027 8.4375 5.45924 8.4375 5.625V12.5C8.4375 13.3288 8.10826 14.1237 7.52221 14.7097C6.93616 15.2958 6.1413 15.625 5.3125 15.625"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M17.5 11.25H12.1875C12.0217 11.25 11.8628 11.1842 11.7456 11.0669C11.6283 10.9497 11.5625 10.7908 11.5625 10.625V5.625C11.5625 5.45924 11.6283 5.30027 11.7456 5.18306C11.8628 5.06585 12.0217 5 12.1875 5H16.875C17.0408 5 17.1997 5.06585 17.3169 5.18306C17.4342 5.30027 17.5 5.45924 17.5 5.625V12.5C17.5 13.3288 17.1708 14.1237 16.5847 14.7097C15.9987 15.2958 15.2038 15.625 14.375 15.625"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1474_15462">
					<rect width="20" height="20" fill="currentColor" />
				</clipPath>
			</defs>
		</>
	),
});

export const BizyBeeOutline = createIconFromPath({
	displayName: 'BizyBeeOutline',
	viewBox: '0 0 20 20',
	path: (
		<g stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none">
			<path d="m4.1936 15.8066-1.16131 1.1614" />
			<path d="m13.7405 3.62971c.7514-.75135.9768-2.02863.3757-2.62971" />
			<path d="m16.3703 6.25995c.7513-.75135 2.0286-.97675 2.6297-.37567" />
			<path d="m4.579 4.19366h5.8083l-4.65213 4.65208c-.85138.85139-2.23175.85139-3.08313 0-1.716741-1.71673-.50087-4.65208 1.92696-4.65208z" />
			<path d="m15.8065 15.4212v-5.80821l-4.6521 4.65211c-.8514.8514-.8514 2.2317 0 3.0831 1.7167 1.7167 4.6521.5009 4.6521-1.927z" />
			<path
				d="M19.987 6.09V13.754A3.832 3.832 0 0 1 12.323 13.754V6.09A3.832 3.832 0 0 1 19.987 6.09Z"
				transform="matrix(.70710678 .70710678 -.70710678 .70710678 5.205836 -8.05238)"
			/>
			<path d="m8.64233 6.44727 4.64527 4.64523m-6.89054-2.39996 4.64524 4.64526m-6.89051-2.4 4.64525 4.6452" />
		</g>
	),
});

export const BoldOutline = createIconFromPath({
	displayName: 'BoldOutline',
	viewBox: '0 0 20 20',
	path: (
		<>
			<g clipPath="url(#clip0_1474_15459)">
				<path
					d="M5.625 9.375H11.875C12.7038 9.375 13.4987 9.70424 14.0847 10.2903C14.6708 10.8763 15 11.6712 15 12.5C15 13.3288 14.6708 14.1237 14.0847 14.7097C13.4987 15.2958 12.7038 15.625 11.875 15.625H5.625V3.75H10.9375C11.6834 3.75 12.3988 4.04632 12.9262 4.57376C13.4537 5.10121 13.75 5.81658 13.75 6.5625C13.75 7.30842 13.4537 8.02379 12.9262 8.55124C12.3988 9.07868 11.6834 9.375 10.9375 9.375"
					stroke="currentColor"
					strokeWidth="3"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1474_15459">
					<rect width="20" height="20" fill="currentColor" />
				</clipPath>
			</defs>
		</>
	),
});

export const BookAltOutline = createIconFromPath({
	displayName: 'BookAltOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19 4V20H7C5.89543 20 5 19.1046 5 18V6C5 4.89543 5.89543 4 7 4H19Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M19 16H7C5.89543 16 5 16.8954 5 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M9 8H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</>
	),
});

export const CalendarCancelledOutline = createIconFromPath({
	displayName: 'CalendarCancelledOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path
				d="M8 7V3M16 7V3M5 21L19 21C20.1046 21 21 20.1046 21 19L21 7C21 5.89543 20.1046 5 19 5L5 5C3.89543 5 3 5.89543 3 7L3 19C3 20.1046 3.89543 21 5 21Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M15 10.5L9 16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M15 16.5L9 10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</>
	),
});

export const CelebratePartyPopperOutline = createIconFromPath({
	displayName: 'CelebratePartyPopperOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path
				d="M3.04626 20.0476L7.82567 6.89092C7.86658 6.77834 7.93529 6.67792 8.0254 6.59901C8.11552 6.52009 8.22412 6.46523 8.34112 6.43953C8.45811 6.41382 8.57971 6.41811 8.6946 6.45199C8.8095 6.48586 8.91397 6.54823 8.99831 6.6333L17.3667 15.0017C17.4518 15.086 17.5141 15.1905 17.548 15.3054C17.5819 15.4203 17.5862 15.5419 17.5605 15.6589C17.5348 15.7759 17.4799 15.8845 17.401 15.9746C17.3221 16.0647 17.2217 16.1334 17.1091 16.1743L3.95239 20.9537C3.82582 21.0021 3.68794 21.0128 3.55541 20.9846C3.42288 20.9563 3.30137 20.8903 3.20556 20.7944C3.10974 20.6986 3.04371 20.5771 3.01544 20.4446C2.98717 20.3121 2.99788 20.1742 3.04626 20.0476V20.0476Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.6038 7.97484C14.6038 7.97484 14.6038 5.84277 16.7358 5.84277C18.8679 5.84277 18.8679 3.71069 18.8679 3.71069"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M8.77601 19.2041L4.79614 15.2242" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M12.4717 3V5.13208" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M18.8679 11.5283L20.2893 12.9497" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M18.8679 8.68555L21 7.97485" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M6.5022 10.5326L13.467 17.4974" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</>
	),
});

export const CelebrationStreakOutline = createIconFromPath({
	displayName: 'CelebrationStreakOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path
				d="M3.04626 20.0476L7.82567 6.89092C7.86658 6.77834 7.93529 6.67792 8.0254 6.59901C8.11552 6.52009 8.22412 6.46523 8.34112 6.43953C8.45811 6.41382 8.57971 6.41811 8.6946 6.45199C8.8095 6.48586 8.91397 6.54823 8.99831 6.6333L17.3667 15.0017C17.4518 15.086 17.5141 15.1905 17.548 15.3054C17.5819 15.4203 17.5862 15.5419 17.5605 15.6589C17.5348 15.7759 17.4799 15.8845 17.401 15.9746C17.3221 16.0647 17.2217 16.1334 17.1091 16.1743L3.95239 20.9537C3.82582 21.0021 3.68794 21.0128 3.55541 20.9846C3.42288 20.9563 3.30137 20.8903 3.20556 20.7944C3.10974 20.6986 3.04371 20.5771 3.01544 20.4446C2.98717 20.3121 2.99788 20.1742 3.04626 20.0476V20.0476Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.6035 7.97484C14.6035 7.97484 14.6035 5.84277 16.7356 5.84277C18.8677 5.84277 18.8677 3.71069 18.8677 3.71069"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M8.77577 19.2041L4.7959 15.2242" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M12.4717 3V5.13208" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M18.8682 11.5283L20.2895 12.9497" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M18.8682 8.68555L21.0002 7.97485" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M6.50195 10.5326L13.4667 17.4974" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</>
	),
});

export const ChatEmptyOutline = createIconFromPath({
	displayName: 'ChatEmptyOutline',
	viewBox: '0 0 24 24',
	path: (
		<path
			d="M3 6C3 4.89543 3.89543 4 5 4L19 4C20.1046 4 21 4.89543 21 6V15C21 16.1046 20.1046 17 19 17H14L9 21V17H5C3.89543 17 3 16.1046 3 15L3 6Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	),
});

export const ChecklistOutline = createIconFromPath({
	displayName: 'ChecklistOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<g clipPath="url(#clip0_checklist)">
				<path d="M12 12H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M12 6H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M12 18H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M3.75 6L5.25 7.5L8.25 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M3.75 12L5.25 13.5L8.25 10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M4 18.5L5.5 20L8.5 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			</g>
			<defs>
				<clipPath id="clip0_checklist">
					<rect width="24" height="24" fill="currentColor" />
				</clipPath>
			</defs>
		</>
	),
});

export const CheveronSmallDownOutline = createIconFromPath({
	displayName: 'CheveronSmallDownOutline',
	viewBox: '0 0 24 24',
	path: <path d="M17 9.5L12 14.5L7 9.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />,
});

export const CheveronSmallLeftOutline = createIconFromPath({
	displayName: 'CheveronSmallLeftOutline',
	viewBox: '0 0 24 24',
	path: <path d="M14.5 17L9.5 12L14.5 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />,
});

export const CheveronSmallRightOutline = createIconFromPath({
	displayName: 'CheveronSmallRightOutline',
	viewBox: '0 0 24 24',
	path: <path d="M9.5 7L14.5 12L9.5 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />,
});

export const CheveronSmallUpOutline = createIconFromPath({
	displayName: 'CheveronSmallUpOutline',
	viewBox: '0 0 24 24',
	path: <path d="M7 14.5L12 9.5L17 14.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />,
});

export const ClappingHandsOutline = createIconFromPath({
	displayName: 'ClappingHandsOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path
				d="M4.85626 11.4281C4.74546 11.236 4.59791 11.0677 4.42204 10.9326C4.24618 10.7976 4.04544 10.6985 3.83128 10.6411C3.61713 10.5836 3.39375 10.5689 3.17391 10.5978C2.95407 10.6266 2.74207 10.6985 2.55001 10.8093C2.35795 10.9201 2.1896 11.0677 2.05456 11.2435C1.91953 11.4194 1.82045 11.6202 1.76299 11.8343C1.70554 12.0485 1.69083 12.2718 1.7197 12.4917C1.74857 12.7115 1.82046 12.9235 1.93126 13.1156L5.40001 19.125C6.30429 20.657 7.77681 21.7701 9.49738 22.2222C11.218 22.6743 13.0475 22.429 14.5881 21.5394C16.1287 20.6499 17.2559 19.1881 17.7245 17.472C18.1931 15.7558 17.9653 13.9241 17.0906 12.375L15.4969 9.60933C15.2594 9.25113 14.8941 8.99705 14.4757 8.89893C14.0572 8.80082 13.6171 8.86607 13.2451 9.08136C12.8732 9.29666 12.5974 9.64577 12.474 10.0575C12.3506 10.4692 12.389 10.9125 12.5813 11.2968"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.0313 13.6406L6.46881 7.47188C6.35801 7.27983 6.21046 7.11147 6.03459 6.97644C5.85873 6.8414 5.65799 6.74233 5.44383 6.68487C5.22968 6.62741 5.0063 6.6127 4.78646 6.64157C4.56662 6.67044 4.35462 6.74233 4.16256 6.85313C3.9705 6.96394 3.80215 7.11148 3.66711 7.28735C3.53207 7.46322 3.433 7.66396 3.37554 7.87811C3.31809 8.09227 3.30337 8.31564 3.33225 8.53548C3.36112 8.75532 3.43301 8.96733 3.54381 9.15938L7.10631 15.3281"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.0814 13.9031L10.1439 7.07809C9.92009 6.69021 9.55139 6.40711 9.11888 6.29107C8.68638 6.17504 8.22549 6.23556 7.83761 6.45934C7.44973 6.68312 7.16663 7.05181 7.0506 7.48432C6.93456 7.91682 6.99509 8.37771 7.21886 8.76559"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.28136 6.34691L8.31574 4.66879C8.09196 4.28091 7.72326 3.99781 7.29076 3.88177C6.85825 3.76574 6.39737 3.82626 6.00949 4.05004C5.62161 4.27381 5.33851 4.64251 5.22247 5.07502C5.10643 5.50752 5.16696 5.96841 5.39074 6.35629L5.61574 6.74066"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.625 17.9531C18.7692 16.917 19.5243 15.5205 19.7648 13.9958C20.0053 12.471 19.7166 10.9099 18.9468 9.57188L17.3531 6.81563C17.2423 6.62358 17.0947 6.45522 16.9189 6.32019C16.743 6.18515 16.5423 6.08608 16.3281 6.02862C16.114 5.97116 15.8906 5.95645 15.6707 5.98532C15.4509 6.01419 15.2389 6.08608 15.0468 6.19688C14.8548 6.30769 14.6864 6.45523 14.5514 6.6311C14.4164 6.80697 14.3173 7.00771 14.2598 7.22186C14.2024 7.43602 14.1877 7.65939 14.2165 7.87923C14.2454 8.09907 14.3173 8.31108 14.4281 8.50313"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.6437 8.87814L11.9905 4.28439C11.7668 3.89651 11.3981 3.61341 10.9656 3.49737C10.5331 3.38134 10.0722 3.44186 9.68429 3.66564C9.29641 3.88942 9.01331 4.25811 8.89728 4.69062C8.78124 5.12312 8.84176 5.58401 9.06554 5.97189"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M16.575 1.05933L16.1907 2.50308" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M19.4157 2.38123L18.5532 3.60935" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M21.6188 4.58435L20.3906 5.44685" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</>
	),
});

export const ClosedCaptionsOutline = createIconFromPath({
	displayName: 'ClosedCaptionsOutline',
	viewBox: '0 0 20 20',
	path: (
		<>
			<path
				d="M2.6875 3.5H17.3125C17.951 3.5 18.5 4.0427 18.5 4.75V15.25C18.5 15.9573 17.951 16.5 17.3125 16.5H2.6875C2.04899 16.5 1.5 15.9573 1.5 15.25V4.75C1.5 4.0427 2.04899 3.5 2.6875 3.5Z"
				stroke="currentColor"
			/>
			<path
				d="M13.1627 13.5C12.7511 13.5 12.3677 13.412 12.0127 13.236C11.6627 13.06 11.3566 12.8143 11.0941 12.4987C10.8317 12.1831 10.6259 11.813 10.4766 11.3882C10.3325 10.9634 10.2605 10.4991 10.2605 9.99545C10.2605 9.49176 10.3325 9.02752 10.4766 8.60273C10.6207 8.17187 10.824 7.80169 11.0864 7.4922C11.3488 7.17664 11.655 6.9339 12.0049 6.76398C12.36 6.58799 12.7459 6.5 13.1627 6.5C13.5796 6.5 13.9526 6.58192 14.282 6.74577C14.6164 6.90962 14.8995 7.12809 15.131 7.40117C15.3626 7.67425 15.5273 7.97768 15.625 8.31144L14.5676 8.91222C14.4698 8.58453 14.2974 8.31448 14.0504 8.10208C13.8085 7.88362 13.5127 7.77438 13.1627 7.77438C12.8231 7.77438 12.5247 7.86844 12.2674 8.05657C12.0101 8.24469 11.8094 8.50564 11.6653 8.8394C11.5264 9.1671 11.4569 9.55245 11.4569 9.99545C11.4569 10.4384 11.5264 10.8268 11.6653 11.1606C11.8094 11.4944 12.0101 11.7553 12.2674 11.9434C12.5247 12.1316 12.8231 12.2256 13.1627 12.2256C13.5127 12.2256 13.8085 12.1194 14.0504 11.907C14.2974 11.6886 14.4698 11.4155 14.5676 11.0878L15.625 11.6886C15.5273 12.0223 15.3626 12.3257 15.131 12.5988C14.8995 12.8719 14.6164 13.0904 14.282 13.2542C13.9526 13.4181 13.5796 13.5 13.1627 13.5Z"
				fill="currentColor"
			/>
			<path
				d="M7.27725 13.5C6.86558 13.5 6.48222 13.412 6.12716 13.236C5.77724 13.06 5.47106 12.8143 5.20862 12.4987C4.94619 12.1831 4.74035 11.813 4.59112 11.3882C4.44704 10.9634 4.375 10.4991 4.375 9.99545C4.375 9.49176 4.44704 9.02752 4.59112 8.60273C4.73521 8.17187 4.93847 7.80169 5.20091 7.4922C5.46334 7.17664 5.76952 6.9339 6.11944 6.76398C6.4745 6.58799 6.86044 6.5 7.27725 6.5C7.69406 6.5 8.06713 6.58192 8.39647 6.74577C8.73095 6.90962 9.01397 7.12809 9.24553 7.40117C9.47709 7.67425 9.64176 7.97768 9.73953 8.31144L8.68206 8.91222C8.58429 8.58453 8.4119 8.31448 8.1649 8.10208C7.92305 7.88362 7.62717 7.77438 7.27725 7.77438C6.93762 7.77438 6.63917 7.86844 6.38187 8.05657C6.12458 8.24469 5.9239 8.50564 5.77981 8.8394C5.64087 9.1671 5.57141 9.55245 5.57141 9.99545C5.57141 10.4384 5.64087 10.8268 5.77981 11.1606C5.9239 11.4944 6.12458 11.7553 6.38187 11.9434C6.63917 12.1316 6.93762 12.2256 7.27725 12.2256C7.62717 12.2256 7.92305 12.1194 8.1649 11.907C8.4119 11.6886 8.58429 11.4155 8.68206 11.0878L9.73953 11.6886C9.64176 12.0223 9.47709 12.3257 9.24553 12.5988C9.01397 12.8719 8.73095 13.0904 8.39647 13.2542C8.06713 13.4181 7.69406 13.5 7.27725 13.5Z"
				fill="currentColor"
			/>
		</>
	),
});

export const CollaborationMapOutline = createIconFromPath({
	displayName: 'CollaborationMapOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path
				d="M20.4375 9.05906C20.4375 9.68066 20.1906 10.2768 19.751 10.7163C19.3115 11.1559 18.7154 11.4028 18.0938 11.4028C17.4721 11.4028 16.876 11.1559 16.4365 10.7163C15.9969 10.2768 15.75 9.68066 15.75 9.05906C15.75 8.43746 15.9969 7.84132 16.4365 7.40178C16.876 6.96224 17.4721 6.71531 18.0938 6.71531C18.7154 6.71531 19.3115 6.96224 19.751 7.40178C20.1906 7.84132 20.4375 8.43746 20.4375 9.05906ZM12.9375 8.25C12.9375 9.4932 12.4436 10.6855 11.5646 11.5646C10.6855 12.4436 9.4932 12.9375 8.25 12.9375C7.0068 12.9375 5.81451 12.4436 4.93544 11.5646C4.05636 10.6855 3.5625 9.4932 3.5625 8.25C3.5625 7.0068 4.05636 5.81451 4.93544 4.93544C5.81451 4.05636 7.0068 3.5625 8.25 3.5625C9.4932 3.5625 10.6855 4.05636 11.5646 4.93544C12.4436 5.81451 12.9375 7.0068 12.9375 8.25ZM18.5334 17.1562C18.5334 17.5871 18.4486 18.0138 18.2837 18.4119C18.1188 18.81 17.8771 19.1718 17.5724 19.4764C17.2677 19.7811 16.906 20.0228 16.5079 20.1877C16.1098 20.3526 15.6831 20.4375 15.2522 20.4375C14.8213 20.4375 14.3946 20.3526 13.9965 20.1877C13.5984 20.0228 13.2367 19.7811 12.932 19.4764C12.6273 19.1718 12.3856 18.81 12.2207 18.4119C12.0558 18.0138 11.9709 17.5871 11.9709 17.1562C11.9709 16.286 12.3166 15.4514 12.932 14.8361C13.5473 14.2207 14.3819 13.875 15.2522 13.875C16.1224 13.875 16.957 14.2207 17.5724 14.8361C18.1877 15.4514 18.5334 16.286 18.5334 17.1562Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M11 12L13 14.5M16 9L12.5 8.5" stroke="currentColor" strokeWidth="1.5" />
		</>
	),
});

export const CoinPointsOutline = createIconFromPath({
	displayName: 'CoinPointsOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path
				d="M9 11.25C13.1421 11.25 16.5 9.73896 16.5 7.875C16.5 6.01104 13.1421 4.5 9 4.5C4.85786 4.5 1.5 6.01104 1.5 7.875C1.5 9.73896 4.85786 11.25 9 11.25Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M1.5 7.875V11.625C1.5 13.4906 4.85625 15 9 15C13.1438 15 16.5 13.4906 16.5 11.625V7.875"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.5 9.06567C19.9219 9.38442 22.5 10.7438 22.5 12.375C22.5 14.2407 19.1438 15.75 15 15.75C13.1625 15.75 11.475 15.45 10.1719 14.9625"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.5 14.9344V16.125C7.5 17.9906 10.8562 19.5 15 19.5C19.1438 19.5 22.5 17.9906 22.5 16.125V12.375"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
});

export const ContextDrawerCollapseOutline = createIconFromPath({
	displayName: 'ContextDrawerCollapseOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path
				d="M18 17V7C18 5.89543 17.1046 5 16 5H10.5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19H16C17.1046 19 18 18.1046 18 17Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M21 5C21 13.5048 21 10.4952 21 19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</>
	),
});

export const ContextDrawerExpandOutline = createIconFromPath({
	displayName: 'ContextDrawerExpandOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path
				d="M11 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19H11C12.1046 19 13 18.1046 13 17V7C13 5.89543 12.1046 5 11 5Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18 5H19C20.1046 5 21 5.89543 21 7V17C21 18.1046 20.1046 19 19 19H18C16.8954 19 16 18.1046 16 17V7C16 5.89543 16.8954 5 18 5Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
});

export const ContextDrawerOutline = createIconFromPath({
	displayName: 'ContextDrawerOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path d="M7 2H17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M5 6H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M19 10H5C3.89543 10 3 10.8954 3 12V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V12C21 10.8954 20.1046 10 19 10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
});

export const FilterBarsOutline = createIconFromPath({
	displayName: 'FilterBarsOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<rect x="2" y="5" width="20" height="2" rx="1" fill="currentColor" />
			<rect x="4.5" y="11" width="15" height="2" rx="1" fill="currentColor" />
			<rect x="8.5" y="17" width="7" height="2" rx="1" fill="currentColor" />
		</>
	),
});

export const FilterLinesOutline = createIconFromPath({
	displayName: 'FilterLinesOutline',
	viewBox: '0 0 24 24',
	path: <path d="M5 7H19M7 12H17M9 17H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />,
});

export const GetContextOutline = createIconFromPath({
	displayName: 'GetContextOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path d="M7 2H17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M5 6H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M19 10H5C3.89543 10 3 10.8954 3 12V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V12C21 10.8954 20.1046 10 19 10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
});

export const GifOutline = createIconFromPath({
	displayName: 'GifOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path d="M12.75 6.75V17.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M21.375 6.75H16.875V17.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M20.25 12H16.875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M6.75 12.0001H9V14.2501C9 15.0457 8.68393 15.8088 8.12132 16.3714C7.55872 16.934 6.79565 17.2501 6 17.2501C5.20436 17.2501 4.44129 16.934 3.87869 16.3714C3.31608 15.8088 3.00001 15.0457 3.00001 14.2501V9.75005C2.99857 9.01884 3.26423 8.31228 3.74708 7.76315C4.22992 7.21403 4.89669 6.86016 5.62208 6.76805C6.34747 6.67593 7.08153 6.85192 7.68629 7.26294C8.29106 7.67395 8.72489 8.29169 8.90625 9.00005"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
});

export const HistoryOutline = createIconFromPath({
	displayName: 'HistoryOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path d="M12 7.5V12L15.75 14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M6.75 9.75H3V6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M6.3375 17.9999C7.51685 19.1127 8.99798 19.8533 10.5958 20.1292C12.1937 20.4051 13.8374 20.204 15.3217 19.5511C16.8059 18.8981 18.0648 17.8222 18.9411 16.4579C19.8173 15.0936 20.2721 13.5013 20.2486 11.8799C20.2251 10.2586 19.7244 8.68013 18.8089 7.34177C17.8934 6.00341 16.6039 4.9645 15.1014 4.35485C13.5988 3.74519 11.95 3.59182 10.3608 3.91391C8.77157 4.23599 7.31253 5.01925 6.16594 6.16581C5.0625 7.28331 4.15125 8.33706 3 9.74987"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
});

export const ImageUploadOutline = createIconFromPath({
	displayName: 'ImageUploadOutline',
	viewBox: '0 0 26 26',
	path: (
		<>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.33333 0.25C1.63046 0.25 0.25 1.63046 0.25 3.33333V15V17.3333C0.25 19.0362 1.63046 20.4167 3.33333 20.4167H13.2516C13.2175 20.1492 13.2 19.8767 13.2 19.6C13.2 19.3692 13.2122 19.1412 13.236 18.9167H3.33333C2.45888 18.9167 1.75 18.2078 1.75 17.3333V15.3107L6.88041 10.1802C7.49874 9.56192 8.50126 9.56192 9.11959 10.1802L12.1358 13.1965L12.1363 13.197L12.1369 13.1975L14.4697 15.5303C14.5054 15.566 14.5438 15.5974 14.5842 15.6244C14.89 15.2392 15.2392 14.89 15.6244 14.5842C15.5974 14.5438 15.566 14.5054 15.5303 14.4697L13.7273 12.6667L15.0471 11.3469C15.6654 10.7286 16.6679 10.7286 17.2863 11.3469L18.9167 12.9773V13.236C19.1412 13.2122 19.3691 13.2 19.6 13.2C19.8766 13.2 20.1492 13.2176 20.4167 13.2516V12.6667V3.33333C20.4167 1.63046 19.0362 0.25 17.3333 0.25H3.33333ZM10.1802 9.11959L12.6667 11.606L13.9864 10.2863C15.1905 9.08214 17.1428 9.08214 18.3469 10.2863L18.9167 10.856V3.33333C18.9167 2.45888 18.2078 1.75 17.3333 1.75H3.33333C2.45888 1.75 1.75 2.45888 1.75 3.33333V13.1893L5.81975 9.11959C7.02387 7.91547 8.97613 7.91547 10.1802 9.11959ZM12.6667 4.91667C12.2525 4.91667 11.9167 5.25245 11.9167 5.66667C11.9167 6.08088 12.2525 6.41667 12.6667 6.41667H12.6783C13.0925 6.41667 13.4283 6.08088 13.4283 5.66667C13.4283 5.25245 13.0925 4.91667 12.6783 4.91667H12.6667Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.6 26.0002C23.1346 26.0002 26 23.1348 26 19.6002C26 16.0656 23.1346 13.2002 19.6 13.2002C16.0653 13.2002 13.2 16.0656 13.2 19.6002C13.2 23.1348 16.0653 26.0002 19.6 26.0002ZM22.5656 19.0345L20.1656 16.6345C19.8532 16.3221 19.3467 16.3221 19.0343 16.6345L16.6343 19.0345C16.3218 19.3469 16.3218 19.8535 16.6343 20.1659C16.9467 20.4783 17.4532 20.4783 17.7656 20.1659L18.8 19.1316V22.0002C18.8 22.442 19.1581 22.8002 19.6 22.8002C20.0418 22.8002 20.4 22.442 20.4 22.0002V19.1316L21.4343 20.1659C21.7467 20.4783 22.2532 20.4783 22.5656 20.1659C22.8781 19.8535 22.8781 19.3469 22.5656 19.0345Z"
				fill="currentColor"
			/>
		</>
	),
});

export const ItalicOutline = createIconFromPath({
	displayName: 'ItalicOutline',
	viewBox: '0 0 20 20',
	path: (
		<>
			<g clipPath="url(#clip0_1474_15465)">
				<path d="M11.875 4.375L8.125 15.625" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M5 15.625H11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M8.75 4.375H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			</g>
			<defs>
				<clipPath id="clip0_1474_15465">
					<rect width="20" height="20" fill="currentColor" />
				</clipPath>
			</defs>
		</>
	),
});

export const LeftDrawerCollapseOutline = createIconFromPath({
	displayName: 'LeftDrawerCollapseOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path
				d="M19 4H5C3.89543 4 3 4.89543 3 6V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V6C21 4.89543 20.1046 4 19 4Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M6 6.5C6 13.1823 6 10.8177 6 17.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</>
	),
});

export const LeftDrawerExpandOutline = createIconFromPath({
	displayName: 'LeftDrawerExpandOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path
				d="M19 4H5C3.89543 4 3 4.89543 3 6V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V6C21 4.89543 20.1046 4 19 4Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M9 5C9 13.5048 9 10.4952 9 19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</>
	),
});

export const LifeRaftOutline = createIconFromPath({
	displayName: 'LifeRaftOutline',
	viewBox: '0 0 20 20',
	path: (
		<path
			d="M18.25 10C18.25 14.5563 14.5563 18.25 10 18.25V19.75C15.3848 19.75 19.75 15.3848 19.75 10H18.25ZM10 18.25C5.44365 18.25 1.75 14.5563 1.75 10H0.25C0.25 15.3848 4.61522 19.75 10 19.75V18.25ZM1.75 10C1.75 5.44365 5.44365 1.75 10 1.75V0.25C4.61522 0.25 0.25 4.61522 0.25 10H1.75ZM10 1.75C14.5563 1.75 18.25 5.44365 18.25 10H19.75C19.75 4.61522 15.3848 0.25 10 0.25V1.75ZM13.25 10C13.25 11.7949 11.7949 13.25 10 13.25V14.75C12.6234 14.75 14.75 12.6234 14.75 10H13.25ZM10 13.25C8.20507 13.25 6.75 11.7949 6.75 10H5.25C5.25 12.6234 7.37665 14.75 10 14.75V13.25ZM6.75 10C6.75 8.20507 8.20507 6.75 10 6.75V5.25C7.37665 5.25 5.25 7.37665 5.25 10H6.75ZM10 6.75C11.7949 6.75 13.25 8.20507 13.25 10H14.75C14.75 7.37665 12.6234 5.25 10 5.25V6.75ZM15.8336 3.10571L12.2981 6.64124L13.3588 7.7019L16.8943 4.16637L15.8336 3.10571ZM12.2981 13.3588L15.8336 16.8943L16.8943 15.8336L13.3588 12.2981L12.2981 13.3588ZM7.7019 6.64124L4.16637 3.10571L3.10571 4.16637L6.64124 7.7019L7.7019 6.64124ZM6.64124 12.2981L3.10571 15.8336L4.16637 16.8943L7.7019 13.3588L6.64124 12.2981Z"
			fill="currentColor"
		/>
	),
});

export const LinkAltOutline = createIconFromPath({
	displayName: 'LinkAltOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path d="M8.82178 15.1781L15.178 8.8125" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M13.5937 16.7719L10.9406 19.425C10.5226 19.843 10.0264 20.1745 9.4803 20.4007C8.93419 20.6269 8.34887 20.7434 7.75777 20.7434C6.56398 20.7434 5.41909 20.2691 4.57496 19.425C3.73082 18.5809 3.25659 17.436 3.25659 16.2422C3.25659 15.0484 3.73082 13.9035 4.57496 13.0594L7.22808 10.4062"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.7719 13.5937L19.425 10.9406C20.2691 10.0964 20.7434 8.95156 20.7434 7.75777C20.7434 6.56398 20.2691 5.41909 19.425 4.57496C18.5809 3.73082 17.436 3.25659 16.2422 3.25659C15.0484 3.25659 13.9035 3.73082 13.0594 4.57496L10.4062 7.22808"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
});

export const ListOutline = createIconFromPath({
	displayName: 'ListOutline',
	viewBox: '0 0 20 20',
	path: (
		<>
			<path d="M6.875 5H16.875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M6.875 10H16.875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M6.875 15H16.875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M3.4375 5.9375C3.95527 5.9375 4.375 5.51777 4.375 5C4.375 4.48223 3.95527 4.0625 3.4375 4.0625C2.91973 4.0625 2.5 4.48223 2.5 5C2.5 5.51777 2.91973 5.9375 3.4375 5.9375Z"
				fill="currentColor"
			/>
			<path
				d="M3.4375 10.9375C3.95527 10.9375 4.375 10.5178 4.375 10C4.375 9.48223 3.95527 9.0625 3.4375 9.0625C2.91973 9.0625 2.5 9.48223 2.5 10C2.5 10.5178 2.91973 10.9375 3.4375 10.9375Z"
				fill="currentColor"
			/>
			<path
				d="M3.4375 15.9375C3.95527 15.9375 4.375 15.5178 4.375 15C4.375 14.4822 3.95527 14.0625 3.4375 14.0625C2.91973 14.0625 2.5 14.4822 2.5 15C2.5 15.5178 2.91973 15.9375 3.4375 15.9375Z"
				fill="currentColor"
			/>
		</>
	),
});

export const MediaOutline = createIconFromPath({
	displayName: 'MediaOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<rect
				x="5.92627"
				y="6.05078"
				width="13.1242"
				height="13.1242"
				rx="2.48449"
				transform="rotate(-15 5.92627 6.05078)"
				stroke="currentColor"
				strokeWidth="1.5"
			/>
			<path
				d="M15.3333 18.7857L15.3333 18.8613C15.3333 20.2334 14.221 21.3458 12.8488 21.3458L4.48449 21.3458C3.11234 21.3458 2 20.2334 2 18.8613L2 11.4493C2 10.0772 3.11234 8.96484 4.48449 8.96484L4.5745 8.96484"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M6.20923 15.0855C6.48925 15.3907 6.96368 15.4112 7.26891 15.1312C7.57414 14.8511 7.59457 14.3767 7.31455 14.0715L6.20923 15.0855ZM6.09468 13.8512L6.64734 13.3442L6.09468 13.8512ZM2.51858 18.0779L6.37668 14.3854L5.33953 13.3017L1.48142 16.9942L2.51858 18.0779ZM5.54202 14.3582L6.20923 15.0855L7.31455 14.0715L6.64734 13.3442L5.54202 14.3582ZM6.37668 14.3854C6.14004 14.6119 5.76347 14.5996 5.54202 14.3582L6.64734 13.3442C6.30037 12.966 5.71033 12.9468 5.33953 13.3017L6.37668 14.3854Z"
				fill="currentColor"
			/>
			<path
				d="M12.7647 13.8645L11.4025 8.78071C11.3324 8.51919 11.5886 8.28862 11.8413 8.38576L16.0615 10.0081C16.2728 10.0893 16.3422 10.3537 16.1981 10.5282L13.3401 13.9897C13.1687 14.1973 12.8344 14.1246 12.7647 13.8645Z"
				stroke="currentColor"
				strokeWidth="1.5"
			/>
		</>
	),
});

export const MegaphoneOutline = createIconFromPath({
	displayName: 'MegaphoneOutline',
	viewBox: '0 0 24 24',
	path: (
		<path
			d="M11 5.88218V19.2402C11 20.2121 10.2121 21 9.24018 21C8.49646 21 7.83302 20.5325 7.58288 19.8321L5.43647 13.6829M18 13C19.6569 13 21 11.6569 21 10C21 8.34315 19.6569 7 18 7M5.43647 13.6829C4.0043 13.0741 3 11.6543 3 10C3 7.79086 4.79086 6 6.99999 6H8.83208C12.9327 6 16.4569 4.7659 18 3L18 17C16.4569 15.2341 12.9327 14 8.83208 14L6.99998 14C6.44518 14 5.91677 13.887 5.43647 13.6829Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	),
});

export const NoRepeatOutline = createIconFromPath({
	displayName: 'NoRepeatOutline',
	viewBox: '0 0 24 24',
	path: (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.875 4.00018C4.875 3.58597 4.53921 3.25018 4.125 3.25018C3.71079 3.25018 3.375 3.58597 3.375 4.00018V9.00018C3.375 9.4144 3.71079 9.75018 4.125 9.75018H4.70652H9.125C9.53921 9.75018 9.875 9.4144 9.875 9.00018C9.875 8.58597 9.53921 8.25018 9.125 8.25018H5.91871C7.18958 6.15148 9.49431 4.75018 12.125 4.75018C13.1751 4.75018 14.1711 4.97295 15.07 5.37309C15.4484 5.54153 15.8917 5.37131 16.0602 4.9929C16.2286 4.61448 16.0584 4.17116 15.68 4.00272C14.5928 3.51877 13.3893 3.25018 12.125 3.25018C9.10735 3.25018 6.44767 4.77761 4.875 7.09993V4.00018ZM20.2386 8.71864C20.0832 8.33469 19.646 8.14944 19.262 8.30486C18.8781 8.46029 18.6928 8.89754 18.8482 9.28148C19.0794 9.85257 19.2399 10.4599 19.3189 11.093C19.3701 11.504 19.7449 11.7957 20.1559 11.7444C20.5669 11.6932 20.8586 11.3184 20.8073 10.9074C20.712 10.1431 20.5181 9.40901 20.2386 8.71864ZM4.93113 12.9074C4.87988 12.4963 4.50512 12.2047 4.09409 12.2559C3.68306 12.3072 3.3914 12.682 3.44266 13.093C3.5443 13.9081 3.75812 14.6888 4.06822 15.4188C4.23017 15.8 4.67052 15.9778 5.05176 15.8159C5.433 15.6539 5.61077 15.2136 5.44881 14.8323C5.19228 14.2284 5.01532 13.5825 4.93113 12.9074ZM15.125 14.2502C14.7108 14.2502 14.375 14.586 14.375 15.0002C14.375 15.4144 14.7108 15.7502 15.125 15.7502H18.3313C17.0604 17.8489 14.7557 19.2502 12.125 19.2502C11.248 19.2502 10.4089 19.0948 9.63281 18.8107C9.24383 18.6683 8.81308 18.8682 8.6707 19.2572C8.52832 19.6462 8.72822 20.0769 9.11719 20.2193C10.0561 20.563 11.0695 20.7502 12.125 20.7502C15.1426 20.7502 17.8023 19.2228 19.375 16.9004V20.0002C19.375 20.4144 19.7108 20.7502 20.125 20.7502C20.5392 20.7502 20.875 20.4144 20.875 20.0002V15.0002C20.875 14.586 20.5392 14.2502 20.125 14.2502H19.5435H15.125ZM19.8163 5.00457C20.095 4.69807 20.0724 4.22374 19.7659 3.94511C19.4594 3.66648 18.9851 3.68906 18.7064 3.99556L5.07004 18.9956C4.79141 19.3021 4.814 19.7764 5.1205 20.055C5.42699 20.3337 5.90132 20.3111 6.17996 20.0046L19.8163 5.00457Z"
			fill="currentColor"
		/>
	),
});

export const OrderedListOutline = createIconFromPath({
	displayName: 'OrderedListOutline',
	viewBox: '0 0 20 20',
	path: (
		<>
			<path d="M8.125 10H16.875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M8.125 5H16.875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M8.125 15H16.875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M4.375 8.125V3.125L3.125 3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M5.625 16.25H3.125L5.36563 13.2524C5.46726 13.1221 5.5415 12.9726 5.5839 12.8129C5.62629 12.6532 5.63595 12.4865 5.61231 12.323C5.58867 12.1595 5.5322 12.0024 5.44631 11.8612C5.36042 11.7201 5.24687 11.5977 5.1125 11.5016C4.83867 11.3017 4.49804 11.2156 4.16212 11.2615C3.8262 11.3074 3.52113 11.4816 3.31094 11.7477C3.23187 11.8493 3.16914 11.9626 3.125 12.0836"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
});

export const PageRightOutline = createIconFromPath({
	displayName: 'PageRightOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path d="M7.75 6.6875H18.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
			<path d="M7.75 11.4375H13.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
			<path
				d="M4.5625 5C4.5625 4.68934 4.31066 4.4375 4 4.4375C3.68934 4.4375 3.4375 4.68934 3.4375 5H4.5625ZM20.3977 19.3977C20.6174 19.1781 20.6174 18.8219 20.3977 18.6023L16.818 15.0225C16.5983 14.8029 16.2422 14.8029 16.0225 15.0225C15.8029 15.2422 15.8029 15.5983 16.0225 15.818L19.2045 19L16.0225 22.182C15.8029 22.4017 15.8029 22.7578 16.0225 22.9775C16.2422 23.1971 16.5983 23.1971 16.818 22.9775L20.3977 19.3977ZM3.4375 5V13H4.5625V5H3.4375ZM10 19.5625H20V18.4375H10V19.5625ZM3.4375 13C3.4375 16.6244 6.37563 19.5625 10 19.5625V18.4375C6.99695 18.4375 4.5625 16.003 4.5625 13H3.4375Z"
				fill="currentColor"
			/>
		</>
	),
});

export const PinOutline = createIconFromPath({
	displayName: 'PinOutline',
	viewBox: '0 0 25 24',
	path: (
		<>
			<path
				d="M22.0307 9.21937C22.1712 9.07874 22.2502 8.88805 22.2502 8.68922C22.2502 8.49039 22.1712 8.2997 22.0307 8.15906L16.3438 2.46937C16.2032 2.32883 16.0125 2.24988 15.8137 2.24988C15.6148 2.24988 15.4241 2.32883 15.2835 2.46937L9.91163 7.85625C9.91163 7.85625 7.31007 6.55594 4.53132 8.79844C4.44892 8.86439 4.38137 8.947 4.33308 9.04085C4.2848 9.13471 4.25687 9.2377 4.25111 9.34309C4.24536 9.44848 4.26192 9.5539 4.2997 9.65245C4.33749 9.751 4.39565 9.84047 4.47038 9.915L14.586 20.0297C14.6618 20.1049 14.7527 20.1631 14.8528 20.2003C14.9528 20.2375 15.0596 20.253 15.1661 20.2456C15.2726 20.2383 15.3763 20.2082 15.4703 20.1576C15.5643 20.1069 15.6463 20.0368 15.711 19.9519C16.4976 18.9056 17.7332 16.7559 16.6588 14.6081L22.0307 9.21937Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M9.52719 14.9728L5 19.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</>
	),
});

export const PlantOutline = createIconFromPath({
	displayName: 'PlantOutline',
	viewBox: '0 0 24 24',
	path: (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.9865 7.85288C13.421 6.41976 14.3937 5.13785 15.8246 4.32669C17.2598 3.51306 18.8883 3.32505 20.3837 3.67843C20.4122 3.68518 20.4294 3.70034 20.4396 3.71796C20.4496 3.73533 20.4536 3.75617 20.4456 3.78236C20.0112 5.21548 19.0385 6.49739 17.6076 7.30855C16.1724 8.12218 14.5439 8.31019 13.0485 7.95681C13.0199 7.95006 13.0028 7.93491 12.9926 7.91729C12.9826 7.89991 12.9786 7.87908 12.9865 7.85288ZM5.79253 8.615C7.51172 9.58961 9.45429 9.8382 11.25 9.45929V12.4944C9.50466 12.6435 7.9833 13.5737 7.05384 14.9316C6.85207 14.8972 6.64493 14.8793 6.43405 14.8793C4.45373 14.8793 2.82447 16.4587 2.82447 18.4362C2.82447 20.1703 4.07837 21.599 5.72165 21.9237C5.81878 21.9683 5.92686 21.9932 6.04075 21.9932H17.4485C17.5624 21.9932 17.6705 21.9683 17.7676 21.9237C19.4109 21.599 20.6649 20.1704 20.6649 18.4362C20.6649 16.4587 19.0356 14.8793 17.0553 14.8793C16.8445 14.8793 16.6374 14.8971 16.4357 14.9316C15.5981 13.7079 14.2797 12.8315 12.75 12.5611V9.4289C14.5836 9.85033 16.5817 9.61441 18.3449 8.61489C20.1192 7.60903 21.3361 6.01064 21.8797 4.21727C22.1467 3.33664 21.6166 2.42701 20.7291 2.21729C18.8827 1.78094 16.8655 2.01229 15.0873 3.02035C13.7457 3.7809 12.7228 4.88019 12.0687 6.14639C11.4145 4.88025 10.3917 3.781 9.05013 3.02049C7.27192 2.01242 5.25472 1.78107 3.40825 2.21743C2.5208 2.42716 1.99075 3.33679 2.2577 4.21742C2.80133 6.01077 4.01824 7.60914 5.79253 8.615ZM8.31286 4.32682C9.74372 5.13798 10.7165 6.41988 11.1509 7.85298C11.1588 7.87917 11.1549 7.90001 11.1449 7.91739C11.1347 7.93501 11.1175 7.95016 11.0889 7.95691C9.59355 8.3103 7.96503 8.12229 6.5298 7.30866C5.09894 6.4975 4.12619 5.21561 3.69177 3.7825C3.68383 3.75631 3.68778 3.73547 3.69781 3.7181C3.70798 3.70048 3.72516 3.68532 3.75373 3.67857C5.24911 3.32518 6.87763 3.51319 8.31286 4.32682ZM8.15502 15.9925C8.87354 14.7873 10.2095 13.9734 11.7448 13.9734C13.28 13.9734 14.616 14.7872 15.3345 15.9925C15.5767 16.3988 16.0549 16.5722 16.4862 16.4548C16.6664 16.4057 16.857 16.3793 17.0553 16.3793C18.2336 16.3793 19.1649 17.3133 19.1649 18.4362C19.1649 19.4574 18.3957 20.3217 17.3693 20.4706C17.3337 20.4758 17.2989 20.4834 17.265 20.4932H6.22428C6.19044 20.4834 6.15563 20.4758 6.12001 20.4706C5.0936 20.3217 4.32447 19.4574 4.32447 18.4362C4.32447 17.3133 5.25577 16.3793 6.43405 16.3793C6.63236 16.3793 6.82307 16.4057 7.00324 16.4548C7.43458 16.5723 7.91278 16.3989 8.15502 15.9925Z"
			fill="currentColor"
		/>
	),
});

export const PlugOutline = createIconFromPath({
	displayName: 'PlugOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path d="M7 21H11C12.1046 21 13 20.1046 13 19V16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M7 9H19V12C19 14.2091 17.2091 16 15 16H11C8.79086 16 7 14.2091 7 12V9Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M16 9V3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M6 9H20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M10 9V3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</>
	),
});

export const QuestionMarkCircleAltOutline = createIconFromPath({
	displayName: 'QuestionMarkCircleAltOutline',
	viewBox: '0 0 24 24',
	path: (
		<path
			d="M9.5 9C9.5 8.5 10.2584 7 12.0001 7C13.1902 7 14.5 7.66838 14.5 9.5C14.5 10.5 14 11 13 12C12.5 12.5 12 13 12 13.5M12 16.5C12.0039 16.5 12.01 16.5 12.01 16.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	),
});

export const RecordOutline = createIconFromPath({
	displayName: 'RecordOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<g clipPath="url(#clip0_record)">
				<path
					d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
					fill="none"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeMiterlimit="10"
				/>
				<path d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z" fill="currentColor" />
			</g>
			<defs>
				<clipPath id="clip0_record">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</>
	),
});

export const SearchAltOutline = createIconFromPath({
	displayName: 'SearchAltOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path
				d="M17 10.5C17 14.0899 14.0899 17 10.5 17C6.91015 17 4 14.0899 4 10.5C4 6.91015 6.91015 4 10.5 4C14.0899 4 17 6.91015 17 10.5Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M20 20L15.5 15.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</>
	),
});

export const SmileyFaceOutline = createIconFromPath({
	displayName: 'SmileyFaceOutline',
	viewBox: '0 0 21 20',
	path: (
		<>
			<path
				d="M16.3286 2.46023C20.4975 5.41293 21.4837 11.1854 18.5318 15.3534C15.5797 19.5215 9.80656 20.5075 5.63757 17.5547C1.46858 14.602 0.48277 8.82882 3.4349 4.66074C6.38709 0.492902 12.1597 -0.492475 16.3286 2.46023Z"
				stroke="currentColor"
				strokeWidth="1.5"
			/>
			<rect width="1.96594" height="3.14607" rx="0.982969" transform="matrix(1 0 0.000112838 1 7.65625 5.30859)" fill="currentColor" />
			<rect width="1.96594" height="3.14607" rx="0.982969" transform="matrix(1 0 0.000112838 1 14.6797 5.30859)" fill="currentColor" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.9418 11.2577C16.1618 11.5442 16.108 11.9548 15.8215 12.1748C12.6415 14.6169 9.59272 13.1887 8.45125 12.1371C8.18556 11.8923 8.16859 11.4785 8.41333 11.2128C8.65808 10.9472 9.07187 10.9303 9.33755 11.1751C10.1747 11.9464 12.5075 13.0703 15.0247 11.1373C15.3111 10.9173 15.7218 10.9712 15.9418 11.2577Z"
				fill="currentColor"
			/>
		</>
	),
});

export const SparklyVideoActiveOutline = createIconFromPath({
	displayName: 'SparklyVideoActiveOutline',
	viewBox: '0 0 28 29',
	path: (
		<>
			<path
				d="M17.5 12.1667L22.8116 9.51087C23.5873 9.12302 24.5 9.68709 24.5 10.5544V18.4456C24.5 19.3129 23.5873 19.877 22.8116 19.4891L17.5 16.8333M5.83333 21.5H15.1667C16.4553 21.5 17.5 20.4553 17.5 19.1667V9.83333C17.5 8.54467 16.4553 7.5 15.1667 7.5H5.83333C4.54467 7.5 3.5 8.54467 3.5 9.83333V19.1667C3.5 20.4553 4.54467 21.5 5.83333 21.5Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.5003 11.5835L13.417 14.5002M13.417 14.5002L10.5003 17.4168M13.417 14.5002L7.58362 14.5002"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
});

export const SparklyVideoOutline = createIconFromPath({
	displayName: 'SparklyVideoOutline',
	viewBox: '0 0 28 29',
	path: (
		<>
			<path
				d="M17.5 12.1667L22.8116 9.51087C23.5873 9.12302 24.5 9.68709 24.5 10.5544V18.4456C24.5 19.3129 23.5873 19.877 22.8116 19.4891L17.5 16.8333M5.83333 21.5H15.1667C16.4553 21.5 17.5 20.4553 17.5 19.1667V9.83333C17.5 8.54467 16.4553 7.5 15.1667 7.5H5.83333C4.54467 7.5 3.5 8.54467 3.5 9.83333V19.1667C3.5 20.4553 4.54467 21.5 5.83333 21.5Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.5003 11.5835V14.5002M10.5003 14.5002V17.4168M10.5003 14.5002H13.417M10.5003 14.5002L7.58362 14.5002"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
});

export const SpotlightOutline = createIconFromPath({
	displayName: 'SpotlightOutline',
	viewBox: '0 0 24 24',
	path: (
		<path
			d="M18.1263 18.6153L18.8925 19.3815M20.3049 14.9943L21.3515 15.2748M14.1231 21.1763L14.4036 22.223M14.2645 7.02327L9.62764 2.38643C8.77403 1.53281 7.39004 1.53281 6.53642 2.38643L1.89958 7.02327C1.04596 7.87689 1.04596 9.26088 1.89958 10.1145L6.53642 14.7513M11.1713 16.2973C12.4517 17.5777 14.5277 17.5777 15.8081 16.2973C17.0885 15.0169 17.0885 12.9409 15.8081 11.6605M14.1912 7.09491L18.9076 8.56095C14.6765 12.7921 12.3043 15.1643 8.07311 19.3955L6.60706 14.6791L14.1912 7.09491Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	),
});

export const StrikethroughOutline = createIconFromPath({
	displayName: 'StrikethroughOutline',
	viewBox: '0 0 20 20',
	path: (
		<>
			<g clipPath="url(#clip0_1474_15463)">
				<path d="M3.125 10H16.875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				<path
					d="M5.96328 7.5C5.89871 7.298 5.86654 7.08706 5.86797 6.875C5.86797 5.14922 7.58671 3.75 10 3.75C11.7969 3.75 13.1437 4.52109 13.75 5.625"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M5.625 13.125C5.625 14.8508 7.58359 16.25 10 16.25C12.4164 16.25 14.375 14.8508 14.375 13.125C14.375 11.268 12.6859 10.5469 10.8125 10"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1474_15463">
					<rect width="20" height="20" fill="currentColor" />
				</clipPath>
			</defs>
		</>
	),
});

export const TargetOutline = createIconFromPath({
	displayName: 'TargetOutline',
	viewBox: '0 0 25 24',
	path: (
		<path
			d="M16.5 8V5L19.5 2L20.5 4L22.5 5L19.5 8H16.5ZM16.5 8L12.5 11.9999M22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47715 6.97715 2 12.5 2M17.5 12C17.5 14.7614 15.2614 17 12.5 17C9.73858 17 7.5 14.7614 7.5 12C7.5 9.23858 9.73858 7 12.5 7"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	),
});

export const TextAltOutline = createIconFromPath({
	displayName: 'TextAltOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<g clipPath="url(#clip0_3448_12078)">
				<path d="M12 5.25L12 18.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M5.25 8.25V5.25L18.75 5.25V8.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M9 18.75H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			</g>
			<defs>
				<clipPath id="clip0_3448_12078">
					<rect width="24" height="24" fill="currentColor" />
				</clipPath>
			</defs>
		</>
	),
});

export const TextOutline = createIconFromPath({
	displayName: 'TextOutline',
	viewBox: '0 0 20 20',
	path: (
		<>
			<g clipPath="url(#clip0_1505_136568)">
				<path
					d="M1.51718 15.8136L2.82599 12.4481M10.8835 15.8136L9.48117 12.4481M9.48117 12.4481L6.03883 4.18646L2.82599 12.4481M9.48117 12.4481H2.82599"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M18 15.8135C18 15.8135 18 14.5356 18 13.1267M17.989 10.6459C17.9722 7.20716 13.8013 7.31316 12.8324 9.57399M17.989 10.6459C17.9994 12.7828 12.8213 10.4623 12.8213 13.8757C12.8213 16.5758 18 16.6223 18 13.1267M17.989 10.6459C17.9926 11.3982 18 12.3206 18 13.1267"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1505_136568">
					<rect width="20" height="20" fill="currentColor" />
				</clipPath>
			</defs>
		</>
	),
});

export const TranscriptionOutline = createIconFromPath({
	displayName: 'TranscriptionOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path
				d="M10.796 18.726L5.87392 18.726C4.9006 18.726 4.11157 17.8989 4.11157 16.8788L4.11157 4.87219C4.11157 3.85202 4.9006 3.02502 5.87392 3.02502L14.6857 3.02502C15.659 3.02502 16.448 3.85202 16.448 4.87219L16.448 5.59786M7.63627 10.4137L10.796 10.4137M7.63627 6.71936L12.9233 6.71935"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.4059 18.3558V21.025M16.4059 18.3558C14.4682 18.3558 12.8305 16.9568 12.2983 15.0357M16.4059 18.3558C18.3437 18.3558 19.9814 16.9568 20.5135 15.0357M16.4059 21.025H13.9546M16.4059 21.025H18.8572M16.4059 15.1259C15.3906 15.1259 14.5675 14.2296 14.5675 13.124V10.6343C14.5675 9.52871 15.3906 8.63245 16.4059 8.63245C17.4213 8.63245 18.2444 9.52871 18.2444 10.6343V13.124C18.2444 14.2296 17.4213 15.1259 16.4059 15.1259Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
});

export const TrophyOutline = createIconFromPath({
	displayName: 'TrophyOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path
				d="M6 5.25V10.4156C6 14.1375 8.65 17.2219 11.9583 17.25C12.7498 17.2562 13.5345 17.0861 14.2672 16.7497C15 16.4132 15.6664 15.917 16.2279 15.2896C16.7895 14.6622 17.2352 13.916 17.5393 13.094C17.8435 12.272 18 11.3904 18 10.5V5.25C18 5.05109 17.9298 4.86032 17.8047 4.71967C17.6797 4.57902 17.5101 4.5 17.3333 4.5H6.66667C6.48986 4.5 6.32029 4.57902 6.19526 4.71967C6.07024 4.86032 6 5.05109 6 5.25Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M9 21H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M12 17.25V21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M18 12H18.7033C19.3125 12 19.8966 11.699 20.3273 11.1632C20.758 10.6273 21 9.90062 21 9.14286V7.71429C21 7.52485 20.9395 7.34316 20.8318 7.20921C20.7242 7.07526 20.5781 7 20.4258 7H18.1655"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6 12H5.29665C4.68754 12 4.10338 11.699 3.67267 11.1632C3.24197 10.6273 3 9.90062 3 9.14286V7.71429C3 7.52485 3.06049 7.34316 3.16817 7.20921C3.27584 7.07526 3.42189 7 3.57416 7H5.83447"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
});

export const UnderlineOutline = createIconFromPath({
	displayName: 'UnderlineOutline',
	viewBox: '0 0 20 20',
	path: (
		<>
			<g clipPath="url(#clip0_3250_13512)">
				<path d="M5 17.5H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				<path
					d="M14.375 4.375V10.625C14.375 11.7853 13.9141 12.8981 13.0936 13.7186C12.2731 14.5391 11.1603 15 10 15C8.83968 15 7.72688 14.5391 6.90641 13.7186C6.08594 12.8981 5.625 11.7853 5.625 10.625V4.375"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_3250_13512">
					<rect width="20" height="20" fill="currentColor" />
				</clipPath>
			</defs>
		</>
	),
});

export const UndoOutline = createIconFromPath({
	displayName: 'UndoOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<g clipPath="url(#clip0_2650_156818)">
				<path d="M7.5 12.75L3 8.25L7.5 3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				<path
					d="M7.5 18.75H15.75C17.1424 18.75 18.4777 18.1969 19.4623 17.2123C20.4469 16.2277 21 14.8924 21 13.5C21 12.1076 20.4469 10.7723 19.4623 9.78769C18.4777 8.80312 17.1424 8.25 15.75 8.25H3"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2650_156818">
					<rect width="24" height="24" fill="currentColor" />
				</clipPath>
			</defs>
		</>
	),
});

export const UnpinOutline = createIconFromPath({
	displayName: 'UnpinOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path d="M9.02719 14.9728L4.5 19.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M4.5 3.75L19.5 20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M17.3437 13.4194L21.5297 9.21937C21.6702 9.07874 21.7492 8.88804 21.7492 8.68922C21.7492 8.49039 21.6702 8.2997 21.5297 8.15906L15.8437 2.46937C15.7031 2.32883 15.5124 2.24988 15.3136 2.24988C15.1147 2.24988 14.924 2.32883 14.7834 2.46937L10.9153 6.34687"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.90507 7.49999C6.89444 7.42124 5.48726 7.62374 4.03132 8.79843C3.94892 8.86439 3.88137 8.947 3.83308 9.04085C3.7848 9.1347 3.75687 9.23769 3.75111 9.34308C3.74536 9.44847 3.76192 9.55389 3.7997 9.65244C3.83749 9.751 3.89565 9.84046 3.97038 9.915L14.086 20.0297C14.1618 20.1049 14.2527 20.1631 14.3528 20.2003C14.4528 20.2375 14.5596 20.253 14.6661 20.2456C14.7726 20.2383 14.8763 20.2082 14.9703 20.1576C15.0643 20.1069 15.1463 20.0368 15.211 19.9519C15.6994 19.3022 16.3613 18.2278 16.5348 16.9912"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
});

export const ArrowEnterSolid = createIconFromPath({
	displayName: 'ArrowEnterSolid',
	viewBox: '0 0 14 14',
	path: (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.2002 6.30085V2.80059C11.2002 2.41399 11.5136 2.10059 11.9002 2.10059C12.2868 2.10059 12.6002 2.41399 12.6002 2.80059L12.6002 7.00057H12.6002C12.6002 7.00066 12.6002 7.00076 12.6002 7.00085C12.6002 7.38745 12.2868 7.70085 11.9002 7.70085L3.79016 7.70085L5.39518 9.30588C5.66855 9.57925 5.66855 10.0225 5.39518 10.2958C5.12182 10.5692 4.6786 10.5692 4.40523 10.2958L1.60523 7.49583C1.33187 7.22246 1.33187 6.77925 1.60523 6.50588L4.40523 3.70588C4.6786 3.43251 5.12182 3.43251 5.39518 3.70588C5.66855 3.97925 5.66855 4.42246 5.39518 4.69583L3.79016 6.30085L11.2002 6.30085Z"
			fill="currentColor"
		/>
	),
});

export const BonuslySolid = createIconFromPath({
	displayName: 'BonuslySolid',
	viewBox: '0 0 24 24',
	path: (
		<path
			d="M4.42313 5.49847C4.53098 5.485 4.6262 5.56469 4.6262 5.67132V8.73661C4.6262 12.0017 4.79486 17.5239 10.5888 17.5239C14.1581 17.5239 16.5571 14.7269 16.5571 11.4483C16.5571 8.16979 13.6716 5.73418 10.0794 5.73418C9.63882 5.73418 9.28201 6.08325 9.28201 6.51425V8.63896C9.28201 8.63896 10.1436 8.63672 10.3249 8.63672C12.771 8.63672 13.6005 10.4348 13.6005 11.4483C13.6005 13.3486 12.319 14.5956 10.7219 14.5956C8.72671 14.5956 7.5748 13.0354 7.5748 11.4248V4.62749C7.57595 3.72844 8.32056 3 9.23841 3C19.4713 3 22 6.82179 22 9.37638C22 15.8684 14.3325 21 9.34626 21C3.27696 21 2 15.443 2 11.4102C2 6.83638 3.39284 5.63316 4.42313 5.49847Z"
			fill="currentColor"
		/>
	),
});

export const CelebratePartyPopperSolid = createIconFromPath({
	displayName: 'CelebratePartyPopperSolid',
	viewBox: '0 0 24 24',
	path: (
		<>
			<g clipPath="url(#clip0_5863_47163)">
				<path
					d="M10.3593 4.8C10.1831 4.62073 9.96394 4.48956 9.7227 4.41899C9.48146 4.34842 9.22616 4.34081 8.98114 4.39688C8.7339 4.45152 8.50451 4.56787 8.31435 4.73507C8.1242 4.90228 7.97947 5.1149 7.89364 5.35312L2.84052 19.2375C2.76172 19.4635 2.73778 19.7049 2.77068 19.942C2.80358 20.179 2.89237 20.4049 3.02974 20.6008C3.1671 20.7968 3.3491 20.9573 3.5607 21.0691C3.77231 21.1809 4.00747 21.2407 4.24677 21.2438C4.4221 21.244 4.59629 21.2155 4.76239 21.1594L18.6468 16.1063C18.885 16.0204 19.0976 15.8757 19.2648 15.6855C19.432 15.4954 19.5484 15.266 19.603 15.0187C19.6591 14.7737 19.6515 14.5184 19.5809 14.2772C19.5103 14.036 19.3792 13.8168 19.1999 13.6406L10.3593 4.8ZM5.98114 14.9813L7.78114 10.0312L13.9686 16.2188L9.01864 18.0187L5.98114 14.9813ZM14.9999 6.75C15.0137 6.24277 15.1351 5.74426 15.3561 5.2875C15.853 4.29375 16.7905 3.75 17.9999 3.75C18.628 3.75 19.0311 3.53437 19.2843 3.075C19.4133 2.81487 19.4867 2.53071 19.4999 2.24062C19.4999 2.14257 19.5193 2.04549 19.5572 1.95502C19.595 1.86454 19.6504 1.78248 19.7201 1.71358C19.7899 1.64468 19.8726 1.59033 19.9636 1.55366C20.0545 1.517 20.1518 1.49876 20.2499 1.5C20.4488 1.5 20.6396 1.57902 20.7802 1.71967C20.9209 1.86032 20.9999 2.05109 20.9999 2.25C20.9999 3.45937 20.203 5.25 17.9999 5.25C17.3718 5.25 16.9686 5.46563 16.7155 5.925C16.5865 6.18513 16.513 6.46929 16.4999 6.75937C16.4999 6.85743 16.4804 6.95451 16.4426 7.04498C16.4048 7.13546 16.3494 7.21752 16.2797 7.28642C16.2099 7.35532 16.1271 7.40967 16.0362 7.44634C15.9453 7.483 15.8479 7.50124 15.7499 7.5C15.551 7.5 15.3602 7.42098 15.2196 7.28033C15.0789 7.13968 14.9999 6.94891 14.9999 6.75ZM12.7499 3.75V1.5C12.7499 1.30109 12.8289 1.11032 12.9696 0.96967C13.1102 0.829018 13.301 0.75 13.4999 0.75C13.6988 0.75 13.8896 0.829018 14.0302 0.96967C14.1709 1.11032 14.2499 1.30109 14.2499 1.5V3.75C14.2499 3.94891 14.1709 4.13968 14.0302 4.28033C13.8896 4.42098 13.6988 4.5 13.4999 4.5C13.301 4.5 13.1102 4.42098 12.9696 4.28033C12.8289 4.13968 12.7499 3.94891 12.7499 3.75ZM22.2843 11.4656C22.4251 11.6078 22.5041 11.7999 22.5041 12C22.5041 12.2001 22.4251 12.3922 22.2843 12.5344C22.1409 12.673 21.9493 12.7505 21.7499 12.7505C21.5505 12.7505 21.3589 12.673 21.2155 12.5344L19.7155 11.0344C19.5959 10.8887 19.5348 10.7037 19.544 10.5154C19.5533 10.3271 19.6322 10.149 19.7655 10.0157C19.8989 9.88236 20.077 9.8034 20.2653 9.79416C20.4535 9.78491 20.6385 9.84603 20.7843 9.96563L22.2843 11.4656ZM22.7343 7.4625L20.4843 8.2125C20.4089 8.23856 20.3296 8.25125 20.2499 8.25C20.0715 8.25004 19.899 8.18651 19.7632 8.07081C19.6275 7.95511 19.5374 7.79481 19.5092 7.61868C19.4809 7.44255 19.5164 7.26213 19.6092 7.1098C19.702 6.95747 19.8461 6.8432 20.0155 6.7875L22.2655 6.0375C22.3591 6.00672 22.4578 5.99467 22.556 6.00204C22.6542 6.00942 22.7501 6.03606 22.838 6.08046C22.9259 6.12486 23.0042 6.18614 23.0685 6.2608C23.1327 6.33547 23.1816 6.42206 23.2124 6.51562C23.2432 6.60919 23.2552 6.7079 23.2478 6.80613C23.2405 6.90435 23.2138 7.00016 23.1694 7.08809C23.125 7.17601 23.0638 7.25433 22.9891 7.31857C22.9144 7.38281 22.8278 7.43172 22.7343 7.4625Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5863_47163">
					<rect width="24" height="24" fill="currentColor" />
				</clipPath>
			</defs>
		</>
	),
});

export const ChatEmptySolid = createIconFromPath({
	displayName: 'ChatEmptySolid',
	viewBox: '0 0 24 24',
	path: (
		<path
			d="M3 6C3 4.89543 3.89543 4 5 4L19 4C20.1046 4 21 4.89543 21 6V15C21 16.1046 20.1046 17 19 17H14L9 21V17H5C3.89543 17 3 16.1046 3 15L3 6Z"
			fill="currentColor"
		/>
	),
});

export const CheckedBookmarkSolid = createIconFromPath({
	displayName: 'CheckedBookmarkSolid',
	viewBox: '0 0 40 40',
	path: (
		<>
			<path
				d="M13 13C13 11.8954 13.8954 11 15 11H25C26.1046 11 27 11.8954 27 13V29L20 25.5L13 29V13Z"
				fill="currentColor"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M15.9167 19.583L18.2501 21.9163L24.0834 16.083" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</>
	),
});

export const ClappingHandsSolid = createIconFromPath({
	displayName: 'ClappingHandsSolid',
	viewBox: '0 0 24 24',
	path: (
		<>
			<g clipPath="url(#clip0_5863_47164)">
				<path
					d="M19.2655 9.38434L17.6718 6.62809C17.5376 6.39289 17.3583 6.18655 17.1441 6.02094C16.9298 5.85534 16.685 5.73375 16.4236 5.66317C16.1621 5.59259 15.8894 5.57441 15.6209 5.60969C15.3524 5.64496 15.0936 5.733 14.8593 5.86871C14.4415 6.10626 14.1223 6.4853 13.9593 6.93746L12.3093 4.09684C12.1751 3.86164 11.9958 3.6553 11.7816 3.48969C11.5673 3.32409 11.3225 3.2025 11.0611 3.13192C10.7996 3.06134 10.5269 3.04316 10.2584 3.07844C9.98993 3.11371 9.73109 3.20175 9.49679 3.33746C9.07896 3.57501 8.75977 3.95405 8.59679 4.40621C8.31061 3.95762 7.86281 3.63633 7.34619 3.50892C6.82957 3.38151 6.28373 3.45775 5.82179 3.72184C5.58739 3.85777 5.38221 4.03876 5.21809 4.25437C5.05397 4.46998 4.93415 4.71595 4.86554 4.97809C4.78332 5.27111 4.77048 5.57925 4.82804 5.87809C4.46187 5.90612 4.10647 6.01498 3.78742 6.19684C3.22761 6.52213 2.81954 7.05603 2.65261 7.68159C2.48568 8.30716 2.57348 8.97339 2.89679 9.53434L3.08429 9.85309C2.76262 9.89041 2.45261 9.99588 2.17492 10.1625C1.61575 10.486 1.20786 11.0182 1.04087 11.6422C0.873871 12.2663 0.961424 12.9311 1.28429 13.4906L4.75304 19.5C5.49425 20.7859 6.60037 21.823 7.93134 22.48C9.26231 23.137 10.7583 23.3842 12.2299 23.1905C13.7015 22.9968 15.0825 22.3708 16.1981 21.3917C17.3137 20.4126 18.1137 19.1246 18.4968 17.6906L18.5249 17.5687C19.4722 16.4448 20.0512 15.057 20.1837 13.5931C20.3162 12.1293 19.9956 10.66 19.2655 9.38434ZM17.0437 17.3062C16.8426 18.0676 16.4921 18.7813 16.0124 19.4058C15.5328 20.0303 14.9336 20.5531 14.2499 20.9437C12.8723 21.7388 11.2354 21.9544 9.69892 21.543C8.16246 21.1316 6.85221 20.127 6.05617 18.75L2.58742 12.7406C2.49407 12.5803 2.45036 12.3959 2.46182 12.2108C2.47328 12.0257 2.5394 11.8481 2.65181 11.7006C2.76422 11.553 2.91787 11.4422 3.09331 11.382C3.26875 11.3218 3.45811 11.315 3.63742 11.3625C3.87784 11.4299 4.08281 11.5878 4.20929 11.8031L6.45929 15.7031C6.52629 15.8155 6.62087 15.9089 6.73407 15.9745C6.84726 16.0402 6.97534 16.0758 7.10617 16.0781C7.2376 16.0776 7.36659 16.0426 7.48024 15.9766C7.59389 15.9106 7.68819 15.8159 7.75371 15.7019C7.81922 15.588 7.85364 15.4589 7.85352 15.3274C7.85341 15.196 7.81876 15.0669 7.75304 14.9531L4.19054 8.78434C4.06622 8.56802 4.03292 8.31118 4.09798 8.07031C4.16303 7.82944 4.3211 7.62428 4.53742 7.49996C4.75373 7.37564 5.01058 7.34235 5.25144 7.4074C5.49231 7.47245 5.69747 7.63052 5.82179 7.84684L9.38429 14.0156C9.42902 14.1088 9.49255 14.1918 9.57089 14.2594C9.64924 14.3269 9.7407 14.3775 9.83953 14.4079C9.93837 14.4384 10.0424 14.4481 10.1452 14.4364C10.248 14.4248 10.3472 14.392 10.4367 14.3401C10.5262 14.2882 10.6039 14.2184 10.6651 14.135C10.7263 14.0517 10.7696 13.9565 10.7923 13.8556C10.815 13.7547 10.8165 13.6502 10.7969 13.5487C10.7772 13.4471 10.7367 13.3507 10.678 13.2656L7.86554 8.39059C7.74287 8.1739 7.71048 7.91761 7.77541 7.67722C7.84033 7.43683 7.99733 7.23168 8.21242 7.10621C8.42768 6.98399 8.68255 6.95187 8.92141 7.01685C9.16028 7.08183 9.36374 7.23865 9.48742 7.45309L13.4249 14.2781C13.4927 14.3918 13.5888 14.4861 13.7038 14.5518C13.8187 14.6175 13.9487 14.6524 14.0812 14.6531C14.2127 14.6498 14.3415 14.6144 14.4562 14.55C14.6273 14.4501 14.7519 14.2866 14.8028 14.0951C14.8538 13.9036 14.8269 13.6998 14.728 13.5281L13.228 10.9218C13.1049 10.7091 13.0712 10.4563 13.1343 10.2187C13.1643 10.0981 13.2189 9.98508 13.2947 9.88666C13.3706 9.78824 13.466 9.70658 13.5749 9.64684C13.6792 9.58335 13.7956 9.54223 13.9166 9.5261C14.0377 9.50996 14.1607 9.51915 14.278 9.55309C14.3974 9.58302 14.5095 9.63661 14.6077 9.71069C14.706 9.78477 14.7883 9.87783 14.8499 9.98434L16.4437 12.75C16.8406 13.4318 17.098 14.1857 17.201 14.9679C17.304 15.75 17.2506 16.5449 17.0437 17.3062ZM15.4687 2.31559L15.853 0.862464C15.8783 0.767051 15.9221 0.677543 15.9819 0.59905C16.0417 0.520558 16.1164 0.454619 16.2017 0.404997C16.2871 0.355376 16.3813 0.323044 16.4791 0.309849C16.5769 0.296653 16.6764 0.302851 16.7718 0.328089C16.8672 0.353328 16.9567 0.397112 17.0352 0.456942C17.1137 0.516773 17.1796 0.591478 17.2293 0.676792C17.2789 0.762105 17.3112 0.856358 17.3244 0.954166C17.3376 1.05198 17.3314 1.15143 17.3062 1.24684L16.9124 2.69996C16.8707 2.8593 16.7771 3.0002 16.6464 3.10037C16.5156 3.20055 16.3552 3.25428 16.1905 3.25309L15.9937 3.23434C15.8025 3.18171 15.6399 3.05551 15.5415 2.88334C15.4431 2.71116 15.4169 2.50703 15.4687 2.31559ZM17.9343 3.17809L18.7968 1.94996C18.912 1.78698 19.0868 1.67593 19.2833 1.64084C19.4798 1.60574 19.6823 1.64944 19.8468 1.76246C19.9278 1.81945 19.9966 1.8919 20.0495 1.97564C20.1023 2.05938 20.138 2.15274 20.1546 2.25036C20.1711 2.34797 20.1682 2.4479 20.146 2.54438C20.1237 2.64085 20.0826 2.73197 20.0249 2.81246L19.1624 4.04059C19.1063 4.12125 19.0347 4.18993 18.9518 4.24264C18.8688 4.29536 18.7763 4.33104 18.6794 4.34762C18.5826 4.3642 18.4834 4.36134 18.3876 4.33921C18.2919 4.31708 18.2015 4.27612 18.1218 4.21871C17.9594 4.10519 17.8486 3.93204 17.8135 3.73706C17.7783 3.54209 17.8218 3.34114 17.9343 3.17809ZM22.0499 5.20309L20.8218 6.06559C20.6934 6.14945 20.5438 6.19498 20.3905 6.19684C20.2323 6.19559 20.0785 6.1443 19.9511 6.05033C19.8238 5.95636 19.7294 5.82451 19.6816 5.67365C19.6337 5.5228 19.6348 5.36068 19.6847 5.21048C19.7346 5.06029 19.8307 4.92972 19.9593 4.83746L21.1874 3.97496C21.2679 3.91732 21.359 3.87618 21.4555 3.85393C21.552 3.83167 21.6519 3.82874 21.7495 3.8453C21.8471 3.86186 21.9405 3.89758 22.0242 3.95041C22.108 4.00324 22.1804 4.07212 22.2374 4.15309C22.3504 4.31762 22.3941 4.52004 22.359 4.71655C22.324 4.91306 22.2129 5.08784 22.0499 5.20309Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5863_47164">
					<rect width="24" height="24" fill="currentColor" />
				</clipPath>
			</defs>
		</>
	),
});

export const ContextDrawerCollapseSolid = createIconFromPath({
	displayName: 'ContextDrawerCollapseSolid',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.25 7C2.25 5.48122 3.48122 4.25 5 4.25H15C16.5188 4.25 17.75 5.48122 17.75 7V17C17.75 18.5188 16.5188 19.75 15 19.75H5C3.48122 19.75 2.25 18.5188 2.25 17V7ZM5 5.75C4.30964 5.75 3.75 6.30964 3.75 7V17C3.75 17.6904 4.30964 18.25 5 18.25H15C15.6904 18.25 16.25 17.6904 16.25 17V7C16.25 6.30964 15.6904 5.75 15 5.75H5Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.75 5.5C21.75 4.80964 21.1904 4.25 20.5 4.25C19.8096 4.25 19.25 4.80964 19.25 5.5V18.5C19.25 19.1904 19.8096 19.75 20.5 19.75C21.1904 19.75 21.75 19.1904 21.75 18.5V5.5Z"
				fill="currentColor"
			/>
		</>
	),
});

export const ContextDrawerExpandSolid = createIconFromPath({
	displayName: 'ContextDrawerExpandSolid',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.25 7C2.25 5.48122 3.48122 4.25 5 4.25H11C12.5188 4.25 13.75 5.48122 13.75 7V17C13.75 18.5188 12.5188 19.75 11 19.75H5C3.48122 19.75 2.25 18.5188 2.25 17V7ZM5 5.75C4.30964 5.75 3.75 6.30964 3.75 7V17C3.75 17.6904 4.30964 18.25 5 18.25H11C11.6904 18.25 12.25 17.6904 12.25 17V7C12.25 6.30964 11.6904 5.75 11 5.75H5Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.75 7C21.75 5.48122 20.5188 4.25 19 4.25H18C16.4812 4.25 15.25 5.48122 15.25 7V17C15.25 18.5188 16.4812 19.75 18 19.75H19C20.5188 19.75 21.75 18.5188 21.75 17V7Z"
				fill="currentColor"
			/>
		</>
	),
});

export const GetContextSolid = createIconFromPath({
	displayName: 'GetContextSolid',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.25 2C6.25 1.58579 6.58579 1.25 7 1.25H17C17.4142 1.25 17.75 1.58579 17.75 2C17.75 2.41421 17.4142 2.75 17 2.75H7C6.58579 2.75 6.25 2.41421 6.25 2Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.25 6C4.25 5.58579 4.58579 5.25 5 5.25H19C19.4142 5.25 19.75 5.58579 19.75 6C19.75 6.41421 19.4142 6.75 19 6.75H5C4.58579 6.75 4.25 6.41421 4.25 6Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.25 12C2.25 10.4812 3.48122 9.25 5 9.25H19C20.5188 9.25 21.75 10.4812 21.75 12V20C21.75 21.5188 20.5188 22.75 19 22.75H5C3.48122 22.75 2.25 21.5188 2.25 20V12Z"
				fill="currentColor"
			/>
		</>
	),
});

export const HistorySolid = createIconFromPath({
	displayName: 'HistorySolid',
	viewBox: '0 0 25 24',
	path: (
		<>
			<g clipPath="url(#clip0_10485_164)">
				<path
					d="M21.5 12C21.5 13.7578 20.9853 15.4772 20.0193 16.9459C19.0533 18.4146 17.6783 19.5682 16.0642 20.2644C14.45 20.9605 12.6673 21.1687 10.9362 20.8633C9.20505 20.5578 7.60126 19.7521 6.32281 18.5456C6.25116 18.4779 6.19355 18.3967 6.15326 18.3067C6.11298 18.2167 6.09081 18.1197 6.08802 18.0212C6.08524 17.9226 6.10189 17.8245 6.13702 17.7324C6.17216 17.6403 6.2251 17.556 6.29281 17.4843C6.42957 17.3396 6.6182 17.2552 6.81722 17.2495C6.91577 17.2468 7.0139 17.2634 7.10601 17.2985C7.19812 17.3337 7.28241 17.3866 7.35406 17.4543C8.42632 18.4659 9.7729 19.1391 11.2256 19.3897C12.6782 19.6404 14.1725 19.4574 15.5218 18.8636C16.871 18.2698 18.0153 17.2916 18.8118 16.0512C19.6083 14.8107 20.0215 13.3631 20 11.8891C19.9784 10.4152 19.5229 8.98025 18.6905 7.76367C17.858 6.54708 16.6855 5.60279 15.3195 5.04877C13.9535 4.49474 12.4544 4.35557 11.0097 4.64863C9.56504 4.94169 8.23875 5.65399 7.19656 6.69652C6.86563 7.03121 6.55438 7.36027 6.25156 7.68746L7.78063 9.21933C7.88563 9.32422 7.95716 9.45791 7.98615 9.60348C8.01514 9.74904 8.00028 9.89993 7.94347 10.0371C7.88665 10.1742 7.79043 10.2913 7.66699 10.3737C7.54354 10.4562 7.39842 10.5001 7.25 10.5H3.5C3.30109 10.5 3.11032 10.4209 2.96967 10.2803C2.82902 10.1396 2.75 9.94887 2.75 9.74996V5.99996C2.74988 5.85154 2.79381 5.70642 2.87621 5.58297C2.95861 5.45953 3.07579 5.36331 3.21291 5.30649C3.35002 5.24968 3.50092 5.23482 3.64648 5.26381C3.79204 5.2928 3.92573 5.36432 4.03063 5.46933L5.1875 6.62808C5.48938 6.3009 5.80063 5.97183 6.13063 5.63902C7.38883 4.37867 8.99267 3.51993 10.7391 3.1715C12.4856 2.82307 14.2962 3.0006 15.9417 3.68164C17.5872 4.36267 18.9937 5.51659 19.9832 6.99733C20.9726 8.47807 21.5005 10.2191 21.5 12ZM12.5 6.74996C12.3011 6.74996 12.1103 6.82898 11.9697 6.96963C11.829 7.11028 11.75 7.30105 11.75 7.49996V12C11.75 12.1294 11.7834 12.2567 11.8472 12.3694C11.9109 12.4821 12.0028 12.5764 12.1137 12.6431L15.8638 14.8931C15.9482 14.9438 16.0418 14.9774 16.1393 14.9919C16.2367 15.0065 16.3361 15.0017 16.4316 14.9778C16.5272 14.954 16.6172 14.9115 16.6964 14.8529C16.7755 14.7943 16.8424 14.7207 16.8931 14.6362C16.9438 14.5518 16.9774 14.4581 16.992 14.3607C17.0065 14.2633 17.0017 14.1639 16.9779 14.0683C16.954 13.9727 16.9116 13.8828 16.853 13.8036C16.7943 13.7244 16.7207 13.6576 16.6362 13.6068L13.25 11.5753V7.49996C13.25 7.30105 13.171 7.11028 13.0303 6.96963C12.8897 6.82898 12.6989 6.74996 12.5 6.74996Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_10485_164">
					<rect width="24" height="24" fill="currentColor" transform="translate(0.5)" />
				</clipPath>
			</defs>
		</>
	),
});

export const LeftDrawerCollapseSolid = createIconFromPath({
	displayName: 'LeftDrawerCollapseSolid',
	viewBox: '0 0 24 24',
	path: (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5 19.75C3.48122 19.75 2.25 18.5188 2.25 17L2.25 7C2.25 5.48122 3.48122 4.25 5 4.25H8.5L19 4.25C20.5188 4.25 21.75 5.48122 21.75 7V17C21.75 18.5188 20.5188 19.75 19 19.75L8.5 19.75H5ZM7.75 18.25H5C4.30964 18.25 3.75 17.6904 3.75 17L3.75 7C3.75 6.30964 4.30964 5.75 5 5.75H7.75L7.75 18.25ZM9.25 5.75L9.25 18.25L19 18.25C19.6904 18.25 20.25 17.6904 20.25 17V7C20.25 6.30964 19.6904 5.75 19 5.75L9.25 5.75Z"
			fill="currentColor"
		/>
	),
});

export const LeftDrawerExpandSolid = createIconFromPath({
	displayName: 'LeftDrawerExpandSolid',
	viewBox: '0 0 24 24',
	path: (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5 19.75C3.48122 19.75 2.25 18.5188 2.25 17L2.25 7C2.25 5.48122 3.48122 4.25 5 4.25H8.5L19 4.25C20.5188 4.25 21.75 5.48122 21.75 7V17C21.75 18.5188 20.5188 19.75 19 19.75L8.5 19.75H5ZM9.25 5.75L9.25 18.25L19 18.25C19.6904 18.25 20.25 17.6904 20.25 17V7C20.25 6.30964 19.6904 5.75 19 5.75L9.25 5.75Z"
			fill="currentColor"
		/>
	),
});

export const MegaphoneSolid = createIconFromPath({
	displayName: 'MegaphoneSolid',
	viewBox: '0 0 24 24',
	path: (
		<path
			xmlns="http://www.w3.org/2000/svg"
			d="M19.5999 1.6C19.5999 1.18411 19.3846 0.79787 19.0308 0.579222C18.677 0.360574 18.2352 0.340697 17.8632 0.52669L8.51662 5.2H3.9999C2.01168 5.2 0.399902 6.81178 0.399902 8.8C0.399902 10.7882 2.01168 12.4 3.9999 12.4H4.335L6.46149 18.7795C6.62483 19.2695 7.0834 19.6 7.59991 19.6H8.79991C9.46265 19.6 9.99991 19.0627 9.99991 18.4V13.1416L17.8632 17.0733C18.2352 17.2593 18.677 17.2394 19.0308 17.0208C19.3846 16.8021 19.5999 16.4159 19.5999 16V1.6Z"
			fill="currentColor"
		/>
	),
});

export const PauseNoCircleSolid = createIconFromPath({
	displayName: 'PauseNoCircleSolid',
	viewBox: '0 0 20 20',
	path: (
		<>
			<path
				d="M3 5.33333C3 4.04467 4.04467 3 5.33333 3C6.622 3 7.66667 4.04467 7.66667 5.33333V14.6667C7.66667 15.9553 6.622 17 5.33333 17C4.04467 17 3 15.9553 3 14.6667V5.33333Z"
				fill="currentColor"
			/>
			<path
				d="M14.6667 3C13.378 3 12.3333 4.04467 12.3333 5.33333V14.6667C12.3333 15.9553 13.378 17 14.6667 17C15.9553 17 17 15.9553 17 14.6667V5.33333C17 4.04467 15.9553 3 14.6667 3Z"
				fill="currentColor"
			/>
		</>
	),
});

export const PinSolid = createIconFromPath({
	displayName: 'PinSolid',
	viewBox: '0 0 24 24',
	path: (
		<>
			<g clipPath="url(#clip0_11221_3650)">
				<path
					d="M22.0622 9.75006L17.0494 14.7797C17.4769 15.9676 17.6541 17.9569 15.8128 20.4047C15.684 20.5769 15.5196 20.7192 15.3308 20.8219C15.142 20.9246 14.9332 20.9854 14.7188 21.0001C14.6831 21.0001 14.6484 21.0001 14.6128 21.0001C14.4157 21.0001 14.2205 20.9613 14.0384 20.8858C13.8563 20.8104 13.6909 20.6998 13.5516 20.5604L9.02719 16.0313L5.03063 20.0307C4.8899 20.1714 4.69903 20.2505 4.50001 20.2505C4.30098 20.2505 4.11011 20.1714 3.96938 20.0307C3.82865 19.89 3.74959 19.6991 3.74959 19.5001C3.74959 19.301 3.82865 19.1102 3.96938 18.9694L7.96876 14.9729L3.44063 10.4447C3.29179 10.2957 3.17601 10.117 3.10081 9.92028C3.02561 9.72354 2.99269 9.51317 3.00419 9.30287C3.01569 9.09256 3.07134 8.88703 3.16754 8.69966C3.26373 8.51229 3.39831 8.34728 3.56251 8.21537C5.94563 6.29256 8.22657 6.67037 9.22501 6.98349L14.25 1.94068C14.3893 1.80136 14.5547 1.69084 14.7367 1.61543C14.9187 1.54003 15.1138 1.50122 15.3108 1.50122C15.5078 1.50122 15.7029 1.54003 15.8849 1.61543C16.0669 1.69084 16.2323 1.80136 16.3716 1.94068L22.0613 7.62943C22.3425 7.91058 22.5005 8.2919 22.5007 8.68955C22.5009 9.0872 22.3432 9.46866 22.0622 9.75006Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_11221_3650">
					<rect width="24" height="24" fill="currentColor" />
				</clipPath>
			</defs>
		</>
	),
});

export const PlayNoCircleSolid = createIconFromPath({
	displayName: 'PlayNoCircleSolid',
	viewBox: '0 0 20 20',
	path: (
		<path
			d="M8.04222 2.41988C7.24439 1.90845 6.21858 1.86077 5.37317 2.29582C4.52776 2.73087 4 3.57801 4 4.5V14.5C4 15.422 4.52776 16.2691 5.37317 16.7042C6.21858 17.1392 7.24439 17.0916 8.04222 16.5801L15.8422 11.5801C16.5655 11.1165 17 10.3359 17 9.5C17 8.66412 16.5655 7.88354 15.8422 7.41988L8.04222 2.41988Z"
			fill="currentColor"
		/>
	),
});

export const PlusSquareSolid = createIconFromPath({
	displayName: 'PlusSquareSolid',
	viewBox: '0 0 24 24',
	path: (
		<>
			<rect width="24" height="24" rx="8" fill="currentColor" />
			<path d="M8.25 12H15.75" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M12 8.25V15.75" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</>
	),
});

export const TargetSolid = createIconFromPath({
	displayName: 'TargetSolid',
	viewBox: '0 0 64 64',
	path: (
		<>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M32 22.6667C26.8453 22.6667 22.6667 26.8453 22.6667 32C22.6667 37.1546 26.8454 41.3333 32 41.3333C37.1546 41.3333 41.3333 37.1546 41.3333 32C41.3333 30.7113 42.378 29.6667 43.6667 29.6667C44.9554 29.6667 46 30.7113 46 32C46 39.732 39.732 46 32 46C24.268 46 18 39.732 18 32C18 24.268 24.268 18 32 18C33.2887 18 34.3333 19.0447 34.3333 20.3333C34.3333 21.622 33.2887 22.6667 32 22.6667Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.33301 31.9997C6.33301 17.8244 17.8244 6.33301 31.9997 6.33301C33.7546 6.33301 35.4707 6.50948 37.1304 6.84641C38.3935 7.10277 39.2094 8.3344 38.953 9.59729C38.6966 10.8602 37.465 11.6762 36.2022 11.4198C34.8463 11.1446 33.441 10.9997 31.9997 10.9997C20.4017 10.9997 10.9997 20.4017 10.9997 31.9997C10.9997 43.5975 20.4017 52.9997 31.9997 52.9997C43.5975 52.9997 52.9997 43.5975 52.9997 31.9997C52.9997 30.5584 52.8548 29.153 52.5797 27.7969C52.3235 26.534 53.1394 25.3025 54.4025 25.0463C55.6653 24.79 56.8968 25.6061 57.153 26.8691C57.4897 28.5286 57.6663 30.2448 57.6663 31.9997C57.6663 46.1749 46.1749 57.6663 31.9997 57.6663C17.8243 57.6663 6.33301 46.1749 6.33301 31.9997Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M39.0003 21.7013V15.6678C39.0003 15.049 39.2462 14.4555 39.6837 14.0179L46.6529 7.04871C47.9838 5.71781 50.2609 6.40714 50.6301 8.25294L51.4831 12.5182L55.7485 13.3712C57.5941 13.7404 58.2836 16.0176 56.9527 17.3485L49.9903 24.3109C49.5483 24.7528 48.9489 25.0011 48.324 25.0011H42.3001L33.6502 33.6509C32.739 34.5623 31.2615 34.5623 30.3504 33.6509C29.4392 32.7398 29.4392 31.2625 30.3504 30.3511L39.0003 21.7013Z"
				fill="currentColor"
			/>
		</>
	),
});

export const TrophySolid = createIconFromPath({
	displayName: 'TrophySolid',
	viewBox: '0 0 24 24',
	path: (
		<>
			<path
				d="M6 5.25V10.4156C6 14.1375 8.65 17.2219 11.9583 17.25C12.7498 17.2562 13.5345 17.0861 14.2672 16.7497C15 16.4132 15.6664 15.917 16.2279 15.2896C16.7895 14.6622 17.2352 13.916 17.5393 13.094C17.8435 12.272 18 11.3904 18 10.5V5.25C18 5.05109 17.9298 4.86032 17.8047 4.71967C17.6797 4.57902 17.5101 4.5 17.3333 4.5H6.66667C6.48986 4.5 6.32029 4.57902 6.19526 4.71967C6.07024 4.86032 6 5.05109 6 5.25Z"
				fill="currentColor"
			/>
			<path d="M9 21H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M12 17.25V21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M18 12H18.7033C19.3125 12 19.8966 11.699 20.3273 11.1632C20.758 10.6273 21 9.90062 21 9.14286V7.71429C21 7.52485 20.9395 7.34316 20.8318 7.20921C20.7242 7.07526 20.5781 7 20.4258 7H18.1655"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6 12H5.29665C4.68754 12 4.10338 11.699 3.67267 11.1632C3.24197 10.6273 3 9.90062 3 9.14286V7.71429C3 7.52485 3.06049 7.34316 3.16817 7.20921C3.27584 7.07526 3.42189 7 3.57416 7H5.83447"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
});

export const UnpinSolid = createIconFromPath({
	displayName: 'UnpinSolid',
	viewBox: '0 0 24 24',
	path: (
		<>
			<g clipPath="url(#clip0_11221_3649)">
				<path
					d="M22.0622 9.75006L17.5978 14.2294C17.5619 14.2653 17.5191 14.2936 17.4719 14.3124C17.4248 14.3313 17.3743 14.3404 17.3236 14.3391C17.2728 14.3379 17.2228 14.3264 17.1767 14.3053C17.1305 14.2842 17.0891 14.2539 17.055 14.2163L10.125 6.58787C10.0604 6.51662 10.0256 6.42329 10.0279 6.32715C10.0302 6.23102 10.0693 6.13943 10.1372 6.07131L14.25 1.94068C14.3893 1.80136 14.5546 1.69084 14.7367 1.61543C14.9187 1.54003 15.1137 1.50122 15.3108 1.50122C15.5078 1.50122 15.7029 1.54003 15.8849 1.61543C16.0669 1.69084 16.2322 1.80136 16.3715 1.94068L22.0612 7.62943C22.3424 7.91058 22.5005 8.2919 22.5007 8.68955C22.5009 9.0872 22.3431 9.46866 22.0622 9.75006ZM5.05498 3.24568C4.98321 3.16709 4.89553 3.10468 4.79778 3.06258C4.70003 3.02049 4.59444 2.99968 4.48803 3.00155C4.38162 3.00341 4.27682 3.0279 4.1806 3.07338C4.08438 3.11887 3.99895 3.18432 3.92998 3.26537C3.81296 3.40917 3.752 3.59049 3.75837 3.77578C3.76475 3.96106 3.83804 4.13777 3.96466 4.27318L6.31123 6.85787C5.46185 7.03974 4.51873 7.44099 3.56248 8.21537C3.39834 8.34735 3.26384 8.51241 3.16773 8.69982C3.07162 8.88723 3.01605 9.09277 3.00464 9.30308C2.99324 9.51338 3.02624 9.72373 3.10152 9.92043C3.17679 10.1171 3.29265 10.2958 3.44154 10.4447L7.96873 14.9729L3.98904 18.9507C3.85036 19.085 3.76751 19.2667 3.75708 19.4595C3.74665 19.6523 3.80941 19.8419 3.93279 19.9904C4.00016 20.0684 4.0829 20.1317 4.17583 20.1763C4.26876 20.2209 4.36989 20.2459 4.47291 20.2497C4.57593 20.2535 4.67862 20.236 4.77457 20.1983C4.87053 20.1606 4.95768 20.1036 5.0306 20.0307L9.02716 16.0313L13.5544 20.5585C13.6935 20.6983 13.8589 20.8092 14.041 20.885C14.2231 20.9607 14.4184 20.9998 14.6156 21.0001C14.6512 21.0001 14.6859 21.0001 14.7215 21.0001C14.9354 20.9852 15.1435 20.9246 15.3318 20.8222C15.5201 20.7198 15.6841 20.578 15.8128 20.4066C16.2583 19.8262 16.6253 19.1894 16.904 18.5129L18.945 20.7582C19.0108 20.8324 19.0908 20.8929 19.1802 20.936C19.2696 20.9791 19.3666 21.004 19.4657 21.0094C19.5648 21.0147 19.664 21.0003 19.7575 20.967C19.851 20.9338 19.937 20.8822 20.0104 20.8155C20.0839 20.7488 20.1434 20.6681 20.1854 20.5782C20.2274 20.4883 20.2512 20.3909 20.2554 20.2918C20.2595 20.1926 20.2439 20.0936 20.2095 20.0005C20.1751 19.9074 20.1226 19.8221 20.055 19.7494L5.05498 3.24568Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_11221_3649">
					<rect width="24" height="24" fill="currentColor" />
				</clipPath>
			</defs>
		</>
	),
});

export const GiftWrapOutline = createIconFromPath({
	displayName: 'GiftWrapOutline',
	viewBox: '0 0 24 24',
	path: (
		<>
			<mask id="path-1-inside-1_132_2693" fill="white">
				<path d="M17.6553 3.42432C18.8017 3.42432 19.7314 4.35411 19.7314 5.50049V18.2144L14.8018 23.144H3.9043L9.09277 3.42432H17.6553Z" />
			</mask>
			<path
				d="M19.7314 18.2144L20.7921 19.275C21.0734 18.9937 21.2314 18.6122 21.2314 18.2144H19.7314ZM14.8018 23.144V24.644C15.1996 24.644 15.5811 24.486 15.8624 24.2047L14.8018 23.144ZM3.9043 23.144L2.45367 22.7624C2.33531 23.2122 2.43234 23.6915 2.71633 24.0599C3.00033 24.4283 3.43915 24.644 3.9043 24.644L3.9043 23.144ZM9.09277 3.42432V1.92432C8.41134 1.92432 7.81554 2.38364 7.64214 3.04264L9.09277 3.42432ZM17.6553 3.42432V4.92432C17.9732 4.92432 18.2314 5.18254 18.2314 5.50049H19.7314H21.2314C21.2314 3.52568 19.6301 1.92432 17.6553 1.92432V3.42432ZM19.7314 5.50049H18.2314V18.2144H19.7314H21.2314V5.50049H19.7314ZM19.7314 18.2144L18.6708 17.1537L13.7411 22.0834L14.8018 23.144L15.8624 24.2047L20.7921 19.275L19.7314 18.2144ZM14.8018 23.144V21.644H3.9043V23.144V24.644H14.8018V23.144ZM3.9043 23.144L5.35493 23.5257L10.5434 3.80599L9.09277 3.42432L7.64214 3.04264L2.45367 22.7624L3.9043 23.144ZM9.09277 3.42432V4.92432H17.6553V3.42432V1.92432H9.09277V3.42432Z"
				fill="currentColor"
				mask="url(#path-1-inside-1_132_2693)"
			/>
			<mask id="path-3-inside-2_132_2693" fill="white">
				<path d="M9.28569 0.893482C10.9829 1.34833 12.0433 2.99145 11.8127 4.68753L11.841 4.69512L7.47214 20.9998L0.804043 19.2131L5.04979 3.36779C5.0527 3.35645 5.05491 3.34491 5.05794 3.33358C5.06103 3.32207 5.06504 3.31038 5.06824 3.29893L5.17288 2.90841L5.20023 2.91574C5.84856 1.33155 7.58838 0.438688 9.28569 0.893482Z" />
			</mask>
			<path
				d="M9.28569 0.893482C10.9829 1.34833 12.0433 2.99145 11.8127 4.68753L11.841 4.69512L7.47214 20.9998L0.804043 19.2131L5.04979 3.36779C5.0527 3.35645 5.05491 3.34491 5.05794 3.33358C5.06103 3.32207 5.06504 3.31038 5.06824 3.29893L5.17288 2.90841L5.20023 2.91574C5.84856 1.33155 7.58838 0.438688 9.28569 0.893482Z"
				fill="white"
			/>
			<path
				d="M9.28569 0.893482L9.67398 -0.555392L9.67392 -0.555407L9.28569 0.893482ZM11.8127 4.68753L10.3264 4.48542C10.2246 5.23371 10.695 5.94097 11.4244 6.13642L11.8127 4.68753ZM11.841 4.69512L13.2899 5.08335C13.3928 4.69908 13.3389 4.28964 13.14 3.94512C12.9411 3.60059 12.6135 3.34919 12.2292 3.24623L11.841 4.69512ZM7.47214 20.9998L7.08391 22.4487C7.88411 22.6631 8.70661 22.1883 8.92103 21.3881L7.47214 20.9998ZM0.804043 19.2131L-0.644846 18.8249C-0.747811 19.2092 -0.693908 19.6186 -0.494995 19.9631C-0.296083 20.3076 0.0315449 20.559 0.415814 20.662L0.804043 19.2131ZM5.04979 3.36779L6.49868 3.75602C6.49998 3.75113 6.50127 3.74625 6.50253 3.74135L5.04979 3.36779ZM5.05794 3.33358L3.60905 2.94535L3.60901 2.94552L5.05794 3.33358ZM5.06824 3.29893L6.51312 3.70183C6.51448 3.69694 6.51581 3.69205 6.51713 3.68716L5.06824 3.29893ZM5.17288 2.90841L5.56111 1.45952C4.76091 1.2451 3.9384 1.71998 3.72399 2.52018L5.17288 2.90841ZM5.20023 2.91574L4.812 4.36462C5.54144 4.56008 6.30245 4.18278 6.58848 3.48388L5.20023 2.91574ZM9.28569 0.893482L8.89741 2.34236C9.85578 2.59919 10.4566 3.52787 10.3264 4.48542L11.8127 4.68753L13.299 4.88965C13.6301 2.45504 12.1101 0.0974667 9.67398 -0.555392L9.28569 0.893482ZM11.8127 4.68753L11.4244 6.13642L11.4527 6.14401L11.841 4.69512L12.2292 3.24623L12.2009 3.23865L11.8127 4.68753ZM11.841 4.69512L10.3921 4.30689L6.02325 20.6116L7.47214 20.9998L8.92103 21.3881L13.2899 5.08335L11.841 4.69512ZM7.47214 20.9998L7.86037 19.5509L1.19227 17.7642L0.804043 19.2131L0.415814 20.662L7.08391 22.4487L7.47214 20.9998ZM0.804043 19.2131L2.25293 19.6013L6.49868 3.75602L5.04979 3.36779L3.6009 2.97956L-0.644846 18.8249L0.804043 19.2131ZM5.04979 3.36779L6.50253 3.74135C6.50708 3.72363 6.5106 3.70882 6.51281 3.6993C6.51394 3.69445 6.51488 3.69032 6.51552 3.68754C6.51603 3.68529 6.51673 3.68216 6.51678 3.68198C6.517 3.681 6.51688 3.68155 6.51662 3.68264C6.51635 3.68381 6.51579 3.68624 6.51502 3.68948C6.51352 3.6958 6.51075 3.70717 6.50688 3.72163L5.05794 3.33358L3.60901 2.94552C3.60362 2.96565 3.59944 2.98271 3.59658 2.99473C3.59383 3.00627 3.59161 3.01609 3.59086 3.01938C3.58961 3.02494 3.59028 3.02193 3.59092 3.0192C3.5918 3.01539 3.59395 3.00627 3.59705 2.99422L5.04979 3.36779ZM5.05794 3.33358L6.50683 3.7218C6.50306 3.73589 6.49989 3.74671 6.49819 3.75243C6.49661 3.75775 6.49547 3.76139 6.49623 3.75893C6.4963 3.75872 6.49725 3.75564 6.49791 3.75351C6.49873 3.75084 6.49994 3.7469 6.50134 3.74229C6.50406 3.73329 6.50832 3.71904 6.51312 3.70183L5.06824 3.29893L3.62336 2.89603C3.62656 2.88454 3.62912 2.87604 3.6301 2.87282C3.63077 2.87058 3.63157 2.86802 3.62987 2.87353C3.62884 2.87686 3.62592 2.8863 3.62262 2.89741C3.6192 2.90891 3.61437 2.92551 3.60905 2.94535L5.05794 3.33358ZM5.06824 3.29893L6.51713 3.68716L6.62177 3.29663L5.17288 2.90841L3.72399 2.52018L3.61935 2.9107L5.06824 3.29893ZM5.17288 2.90841L4.78465 4.3573L4.812 4.36462L5.20023 2.91574L5.58846 1.46685L5.56111 1.45952L5.17288 2.90841ZM5.20023 2.91574L6.58848 3.48388C6.95454 2.5894 7.93914 2.08559 8.89746 2.34237L9.28569 0.893482L9.67392 -0.555407C7.23762 -1.20821 4.74259 0.0736926 3.81199 2.3476L5.20023 2.91574Z"
				fill="currentColor"
				mask="url(#path-3-inside-2_132_2693)"
			/>
			<circle
				cx="4.22786"
				cy="19.7724"
				r="2.70174"
				transform="rotate(15 4.22786 19.7724)"
				fill="white"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18.4354 16.9165H14.2839C13.7108 16.9165 13.2461 17.3812 13.2461 17.9544V22.1058"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</>
	),
});
